var zr = [
  "auto",
  "light",
  "dark",
  "corporate-blue",
  "brutalist-warm",
  "brutalist-light",
  "minimal-neutral",
  "mocha-mornings"
], sc = [
  {
    id: "auto",
    label: "Auto (follow visitor OS)"
  },
  {
    id: "light",
    label: "Light"
  },
  {
    id: "dark",
    label: "Dark"
  },
  {
    id: "corporate-blue",
    label: "Corporate Blue"
  },
  {
    id: "brutalist-warm",
    label: "Brutalist Warm"
  },
  {
    id: "brutalist-light",
    label: "Brutalist Light"
  },
  {
    id: "minimal-neutral",
    label: "Minimal Neutral"
  },
  {
    id: "mocha-mornings",
    label: "Mocha Mornings"
  }
], Xe;
function p(e, t, r) {
  function n(c, u) {
    if (c._zod || Object.defineProperty(c, "_zod", {
      value: {
        def: u,
        constr: s,
        traits: /* @__PURE__ */ new Set()
      },
      enumerable: !1
    }), c._zod.traits.has(e)) return;
    c._zod.traits.add(e), t(c, u);
    const d = s.prototype, h = Object.keys(d);
    for (let _ = 0; _ < h.length; _++) {
      const g = h[_];
      g in c || (c[g] = d[g].bind(c));
    }
  }
  const i = r?.Parent ?? Object;
  class o extends i {
  }
  Object.defineProperty(o, "name", { value: e });
  function s(c) {
    var u;
    const d = r?.Parent ? new o() : this;
    n(d, c), (u = d._zod).deferred ?? (u.deferred = []);
    for (const h of d._zod.deferred) h();
    return d;
  }
  return Object.defineProperty(s, "init", { value: n }), Object.defineProperty(s, Symbol.hasInstance, { value: (c) => r?.Parent && c instanceof r.Parent ? !0 : c?._zod?.traits?.has(e) }), Object.defineProperty(s, "name", { value: e }), s;
}
var q = class extends Error {
  constructor() {
    super("Encountered Promise during synchronous parse. Use .parseAsync() instead.");
  }
}, Zt = class extends Error {
  constructor(e) {
    super(`Encountered unidirectional transform during encode: ${e}`), this.name = "ZodEncodeError";
  }
};
(Xe = globalThis).__zod_globalConfig ?? (Xe.__zod_globalConfig = {});
var le = globalThis.__zod_globalConfig;
function D(e) {
  return e && Object.assign(le, e), le;
}
function Nt(e) {
  const t = Object.values(e).filter((r) => typeof r == "number");
  return Object.entries(e).filter(([r, n]) => t.indexOf(+r) === -1).map(([r, n]) => n);
}
function Oe(e, t) {
  return typeof t == "bigint" ? t.toString() : t;
}
function fe(e) {
  return { get value() {
    {
      const t = e();
      return Object.defineProperty(this, "value", { value: t }), t;
    }
    throw new Error("cached value already set");
  } };
}
function Me(e) {
  return e == null;
}
function Le(e) {
  const t = e.startsWith("^") ? 1 : 0, r = e.endsWith("$") ? e.length - 1 : e.length;
  return e.slice(t, r);
}
function Pr(e, t) {
  const r = e / t, n = Math.round(r), i = Number.EPSILON * Math.max(Math.abs(r), 1);
  return Math.abs(r - n) < i ? 0 : r - n;
}
var Qe = /* @__PURE__ */ Symbol("evaluating");
function w(e, t, r) {
  let n;
  Object.defineProperty(e, t, {
    get() {
      if (n !== Qe)
        return n === void 0 && (n = Qe, n = r()), n;
    },
    set(i) {
      Object.defineProperty(e, t, { value: i });
    },
    configurable: !0
  });
}
function V(e, t, r) {
  Object.defineProperty(e, t, {
    value: r,
    writable: !0,
    enumerable: !0,
    configurable: !0
  });
}
function L(...e) {
  const t = {};
  for (const r of e) {
    const n = Object.getOwnPropertyDescriptors(r);
    Object.assign(t, n);
  }
  return Object.defineProperties({}, t);
}
function et(e) {
  return JSON.stringify(e);
}
function $r(e) {
  return e.toLowerCase().trim().replace(/[^\w\s-]/g, "").replace(/[\s_-]+/g, "-").replace(/^-+|-+$/g, "");
}
var Ct = "captureStackTrace" in Error ? Error.captureStackTrace : (...e) => {
};
function re(e) {
  return typeof e == "object" && e !== null && !Array.isArray(e);
}
var Tr = /* @__PURE__ */ fe(() => {
  if (le.jitless || typeof navigator < "u" && navigator?.userAgent?.includes("Cloudflare")) return !1;
  try {
    return new Function(""), !0;
  } catch {
    return !1;
  }
});
function Y(e) {
  if (re(e) === !1) return !1;
  const t = e.constructor;
  if (t === void 0 || typeof t != "function") return !0;
  const r = t.prototype;
  return !(re(r) === !1 || Object.prototype.hasOwnProperty.call(r, "isPrototypeOf") === !1);
}
function At(e) {
  return Y(e) ? { ...e } : Array.isArray(e) ? [...e] : e instanceof Map ? new Map(e) : e instanceof Set ? new Set(e) : e;
}
var Er = /* @__PURE__ */ new Set([
  "string",
  "number",
  "symbol"
]);
function X(e) {
  return e.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
function B(e, t, r) {
  const n = new e._zod.constr(t ?? e._zod.def);
  return (!t || r?.parent) && (n._zod.parent = e), n;
}
function f(e) {
  const t = e;
  if (!t) return {};
  if (typeof t == "string") return { error: () => t };
  if (t?.message !== void 0) {
    if (t?.error !== void 0) throw new Error("Cannot specify both `message` and `error` params");
    t.error = t.message;
  }
  return delete t.message, typeof t.error == "string" ? {
    ...t,
    error: () => t.error
  } : t;
}
function Or(e) {
  return Object.keys(e).filter((t) => e[t]._zod.optin === "optional" && e[t]._zod.optout === "optional");
}
var jr = {
  safeint: [Number.MIN_SAFE_INTEGER, Number.MAX_SAFE_INTEGER],
  int32: [-2147483648, 2147483647],
  uint32: [0, 4294967295],
  float32: [-34028234663852886e22, 34028234663852886e22],
  float64: [-Number.MAX_VALUE, Number.MAX_VALUE]
};
function Zr(e, t) {
  const r = e._zod.def, n = r.checks;
  if (n && n.length > 0) throw new Error(".pick() cannot be used on object schemas containing refinements");
  return B(e, L(e._zod.def, {
    get shape() {
      const i = {};
      for (const o in t) {
        if (!(o in r.shape)) throw new Error(`Unrecognized key: "${o}"`);
        t[o] && (i[o] = r.shape[o]);
      }
      return V(this, "shape", i), i;
    },
    checks: []
  }));
}
function Nr(e, t) {
  const r = e._zod.def, n = r.checks;
  if (n && n.length > 0) throw new Error(".omit() cannot be used on object schemas containing refinements");
  return B(e, L(e._zod.def, {
    get shape() {
      const i = { ...e._zod.def.shape };
      for (const o in t) {
        if (!(o in r.shape)) throw new Error(`Unrecognized key: "${o}"`);
        t[o] && delete i[o];
      }
      return V(this, "shape", i), i;
    },
    checks: []
  }));
}
function Cr(e, t) {
  if (!Y(t)) throw new Error("Invalid input to extend: expected a plain object");
  const r = e._zod.def.checks;
  if (r && r.length > 0) {
    const n = e._zod.def.shape;
    for (const i in t) if (Object.getOwnPropertyDescriptor(n, i) !== void 0) throw new Error("Cannot overwrite keys on object schemas containing refinements. Use `.safeExtend()` instead.");
  }
  return B(e, L(e._zod.def, { get shape() {
    const n = {
      ...e._zod.def.shape,
      ...t
    };
    return V(this, "shape", n), n;
  } }));
}
function Ar(e, t) {
  if (!Y(t)) throw new Error("Invalid input to safeExtend: expected a plain object");
  return B(e, L(e._zod.def, { get shape() {
    const r = {
      ...e._zod.def.shape,
      ...t
    };
    return V(this, "shape", r), r;
  } }));
}
function Rr(e, t) {
  if (e._zod.def.checks?.length) throw new Error(".merge() cannot be used on object schemas containing refinements. Use .safeExtend() instead.");
  return B(e, L(e._zod.def, {
    get shape() {
      const r = {
        ...e._zod.def.shape,
        ...t._zod.def.shape
      };
      return V(this, "shape", r), r;
    },
    get catchall() {
      return t._zod.def.catchall;
    },
    checks: t._zod.def.checks ?? []
  }));
}
function Dr(e, t, r) {
  const n = t._zod.def.checks;
  if (n && n.length > 0) throw new Error(".partial() cannot be used on object schemas containing refinements");
  return B(t, L(t._zod.def, {
    get shape() {
      const i = t._zod.def.shape, o = { ...i };
      if (r) for (const s in r) {
        if (!(s in i)) throw new Error(`Unrecognized key: "${s}"`);
        r[s] && (o[s] = e ? new e({
          type: "optional",
          innerType: i[s]
        }) : i[s]);
      }
      else for (const s in i) o[s] = e ? new e({
        type: "optional",
        innerType: i[s]
      }) : i[s];
      return V(this, "shape", o), o;
    },
    checks: []
  }));
}
function xr(e, t, r) {
  return B(t, L(t._zod.def, { get shape() {
    const n = t._zod.def.shape, i = { ...n };
    if (r) for (const o in r) {
      if (!(o in i)) throw new Error(`Unrecognized key: "${o}"`);
      r[o] && (i[o] = new e({
        type: "nonoptional",
        innerType: n[o]
      }));
    }
    else for (const o in n) i[o] = new e({
      type: "nonoptional",
      innerType: n[o]
    });
    return V(this, "shape", i), i;
  } }));
}
function H(e, t = 0) {
  if (e.aborted === !0) return !0;
  for (let r = t; r < e.issues.length; r++) if (e.issues[r]?.continue !== !0) return !0;
  return !1;
}
function Ur(e, t = 0) {
  if (e.aborted === !0) return !0;
  for (let r = t; r < e.issues.length; r++) if (e.issues[r]?.continue === !1) return !0;
  return !1;
}
function G(e, t) {
  return t.map((r) => {
    var n;
    return (n = r).path ?? (n.path = []), r.path.unshift(e), r;
  });
}
function ae(e) {
  return typeof e == "string" ? e : e?.message;
}
function x(e, t, r) {
  const n = e.message ? e.message : ae(e.inst?._zod.def?.error?.(e)) ?? ae(t?.error?.(e)) ?? ae(r.customError?.(e)) ?? ae(r.localeError?.(e)) ?? "Invalid input", { inst: i, continue: o, input: s, ...c } = e;
  return c.path ?? (c.path = []), c.message = n, t?.reportInput && (c.input = s), c;
}
function Be(e) {
  return Array.isArray(e) ? "array" : typeof e == "string" ? "string" : "unknown";
}
function ne(...e) {
  const [t, r, n] = e;
  return typeof t == "string" ? {
    message: t,
    code: "custom",
    input: r,
    inst: n
  } : { ...t };
}
var Rt = (e, t) => {
  e.name = "$ZodError", Object.defineProperty(e, "_zod", {
    value: e._zod,
    enumerable: !1
  }), Object.defineProperty(e, "issues", {
    value: t,
    enumerable: !1
  }), e.message = JSON.stringify(t, Oe, 2), Object.defineProperty(e, "toString", {
    value: () => e.message,
    enumerable: !1
  });
}, Dt = p("$ZodError", Rt), xt = p("$ZodError", Rt, { Parent: Error });
function Mr(e, t = (r) => r.message) {
  const r = {}, n = [];
  for (const i of e.issues) i.path.length > 0 ? (r[i.path[0]] = r[i.path[0]] || [], r[i.path[0]].push(t(i))) : n.push(t(i));
  return {
    formErrors: n,
    fieldErrors: r
  };
}
function Lr(e, t = (r) => r.message) {
  const r = { _errors: [] }, n = (i, o = []) => {
    for (const s of i.issues) if (s.code === "invalid_union" && s.errors.length) s.errors.map((c) => n({ issues: c }, [...o, ...s.path]));
    else if (s.code === "invalid_key") n({ issues: s.issues }, [...o, ...s.path]);
    else if (s.code === "invalid_element") n({ issues: s.issues }, [...o, ...s.path]);
    else {
      const c = [...o, ...s.path];
      if (c.length === 0) r._errors.push(t(s));
      else {
        let u = r, d = 0;
        for (; d < c.length; ) {
          const h = c[d];
          d !== c.length - 1 ? u[h] = u[h] || { _errors: [] } : (u[h] = u[h] || { _errors: [] }, u[h]._errors.push(t(s))), u = u[h], d++;
        }
      }
    }
  };
  return n(e), r;
}
var Fe = (e) => (t, r, n, i) => {
  const o = n ? {
    ...n,
    async: !1
  } : { async: !1 }, s = t._zod.run({
    value: r,
    issues: []
  }, o);
  if (s instanceof Promise) throw new q();
  if (s.issues.length) {
    const c = new (i?.Err ?? e)(s.issues.map((u) => x(u, o, D())));
    throw Ct(c, i?.callee), c;
  }
  return s.value;
}, Je = (e) => async (t, r, n, i) => {
  const o = n ? {
    ...n,
    async: !0
  } : { async: !0 };
  let s = t._zod.run({
    value: r,
    issues: []
  }, o);
  if (s instanceof Promise && (s = await s), s.issues.length) {
    const c = new (i?.Err ?? e)(s.issues.map((u) => x(u, o, D())));
    throw Ct(c, i?.callee), c;
  }
  return s.value;
}, ge = (e) => (t, r, n) => {
  const i = n ? {
    ...n,
    async: !1
  } : { async: !1 }, o = t._zod.run({
    value: r,
    issues: []
  }, i);
  if (o instanceof Promise) throw new q();
  return o.issues.length ? {
    success: !1,
    error: new (e ?? Dt)(o.issues.map((s) => x(s, i, D())))
  } : {
    success: !0,
    data: o.value
  };
}, Br = /* @__PURE__ */ ge(xt), ve = (e) => async (t, r, n) => {
  const i = n ? {
    ...n,
    async: !0
  } : { async: !0 };
  let o = t._zod.run({
    value: r,
    issues: []
  }, i);
  return o instanceof Promise && (o = await o), o.issues.length ? {
    success: !1,
    error: new e(o.issues.map((s) => x(s, i, D())))
  } : {
    success: !0,
    data: o.value
  };
}, Fr = /* @__PURE__ */ ve(xt), Jr = (e) => (t, r, n) => {
  const i = n ? {
    ...n,
    direction: "backward"
  } : { direction: "backward" };
  return Fe(e)(t, r, i);
}, Vr = (e) => (t, r, n) => Fe(e)(t, r, n), Wr = (e) => async (t, r, n) => {
  const i = n ? {
    ...n,
    direction: "backward"
  } : { direction: "backward" };
  return Je(e)(t, r, i);
}, Kr = (e) => async (t, r, n) => Je(e)(t, r, n), Hr = (e) => (t, r, n) => {
  const i = n ? {
    ...n,
    direction: "backward"
  } : { direction: "backward" };
  return ge(e)(t, r, i);
}, Gr = (e) => (t, r, n) => ge(e)(t, r, n), qr = (e) => async (t, r, n) => {
  const i = n ? {
    ...n,
    direction: "backward"
  } : { direction: "backward" };
  return ve(e)(t, r, i);
}, Yr = (e) => async (t, r, n) => ve(e)(t, r, n), Xr = /^[cC][0-9a-z]{6,}$/, Qr = /^[0-9a-z]+$/, en = /^[0-9A-HJKMNP-TV-Za-hjkmnp-tv-z]{26}$/, tn = /^[0-9a-vA-V]{20}$/, rn = /^[A-Za-z0-9]{27}$/, nn = /^[a-zA-Z0-9_-]{21}$/, on = /^P(?:(\d+W)|(?!.*W)(?=\d|T\d)(\d+Y)?(\d+M)?(\d+D)?(T(?=\d)(\d+H)?(\d+M)?(\d+([.,]\d+)?S)?)?)$/, sn = /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12})$/, tt = (e) => e ? new RegExp(`^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-${e}[0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12})$`) : /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/, an = /^(?!\.)(?!.*\.\.)([A-Za-z0-9_'+\-\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\-]*\.)+[A-Za-z]{2,}$/, cn = "^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$";
function un() {
  return new RegExp(cn, "u");
}
var ln = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/, dn = /^(([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:))$/, pn = /^((25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/([0-9]|[1-2][0-9]|3[0-2])$/, hn = /^(([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}|::|([0-9a-fA-F]{1,4})?::([0-9a-fA-F]{1,4}:?){0,6})\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/, mn = /^$|^(?:[0-9a-zA-Z+/]{4})*(?:(?:[0-9a-zA-Z+/]{2}==)|(?:[0-9a-zA-Z+/]{3}=))?$/, Ut = /^[A-Za-z0-9_-]*$/, fn = /^https?$/, gn = /^\+[1-9]\d{6,14}$/, Mt = "(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))", vn = /* @__PURE__ */ new RegExp(`^${Mt}$`);
function Lt(e) {
  const t = "(?:[01]\\d|2[0-3]):[0-5]\\d";
  return typeof e.precision == "number" ? e.precision === -1 ? `${t}` : e.precision === 0 ? `${t}:[0-5]\\d` : `${t}:[0-5]\\d\\.\\d{${e.precision}}` : `${t}(?::[0-5]\\d(?:\\.\\d+)?)?`;
}
function bn(e) {
  return new RegExp(`^${Lt(e)}$`);
}
function yn(e) {
  const t = Lt({ precision: e.precision }), r = ["Z"];
  e.local && r.push(""), e.offset && r.push("([+-](?:[01]\\d|2[0-3]):[0-5]\\d)");
  const n = `${t}(?:${r.join("|")})`;
  return new RegExp(`^${Mt}T(?:${n})$`);
}
var _n = (e) => {
  const t = e ? `[\\s\\S]{${e?.minimum ?? 0},${e?.maximum ?? ""}}` : "[\\s\\S]*";
  return new RegExp(`^${t}$`);
}, wn = /^-?\d+$/, Bt = /^-?\d+(?:\.\d+)?$/, In = /^(?:true|false)$/i, Sn = /^[^A-Z]*$/, kn = /^[^a-z]*$/, N = /* @__PURE__ */ p("$ZodCheck", (e, t) => {
  var r;
  e._zod ?? (e._zod = {}), e._zod.def = t, (r = e._zod).onattach ?? (r.onattach = []);
}), Ft = {
  number: "number",
  bigint: "bigint",
  object: "date"
}, Jt = /* @__PURE__ */ p("$ZodCheckLessThan", (e, t) => {
  N.init(e, t);
  const r = Ft[typeof t.value];
  e._zod.onattach.push((n) => {
    const i = n._zod.bag, o = (t.inclusive ? i.maximum : i.exclusiveMaximum) ?? Number.POSITIVE_INFINITY;
    t.value < o && (t.inclusive ? i.maximum = t.value : i.exclusiveMaximum = t.value);
  }), e._zod.check = (n) => {
    (t.inclusive ? n.value <= t.value : n.value < t.value) || n.issues.push({
      origin: r,
      code: "too_big",
      maximum: typeof t.value == "object" ? t.value.getTime() : t.value,
      input: n.value,
      inclusive: t.inclusive,
      inst: e,
      continue: !t.abort
    });
  };
}), Vt = /* @__PURE__ */ p("$ZodCheckGreaterThan", (e, t) => {
  N.init(e, t);
  const r = Ft[typeof t.value];
  e._zod.onattach.push((n) => {
    const i = n._zod.bag, o = (t.inclusive ? i.minimum : i.exclusiveMinimum) ?? Number.NEGATIVE_INFINITY;
    t.value > o && (t.inclusive ? i.minimum = t.value : i.exclusiveMinimum = t.value);
  }), e._zod.check = (n) => {
    (t.inclusive ? n.value >= t.value : n.value > t.value) || n.issues.push({
      origin: r,
      code: "too_small",
      minimum: typeof t.value == "object" ? t.value.getTime() : t.value,
      input: n.value,
      inclusive: t.inclusive,
      inst: e,
      continue: !t.abort
    });
  };
}), zn = /* @__PURE__ */ p("$ZodCheckMultipleOf", (e, t) => {
  N.init(e, t), e._zod.onattach.push((r) => {
    var n;
    (n = r._zod.bag).multipleOf ?? (n.multipleOf = t.value);
  }), e._zod.check = (r) => {
    if (typeof r.value != typeof t.value) throw new Error("Cannot mix number and bigint in multiple_of check.");
    (typeof r.value == "bigint" ? r.value % t.value === BigInt(0) : Pr(r.value, t.value) === 0) || r.issues.push({
      origin: typeof r.value,
      code: "not_multiple_of",
      divisor: t.value,
      input: r.value,
      inst: e,
      continue: !t.abort
    });
  };
}), Pn = /* @__PURE__ */ p("$ZodCheckNumberFormat", (e, t) => {
  N.init(e, t), t.format = t.format || "float64";
  const r = t.format?.includes("int"), n = r ? "int" : "number", [i, o] = jr[t.format];
  e._zod.onattach.push((s) => {
    const c = s._zod.bag;
    c.format = t.format, c.minimum = i, c.maximum = o, r && (c.pattern = wn);
  }), e._zod.check = (s) => {
    const c = s.value;
    if (r) {
      if (!Number.isInteger(c)) {
        s.issues.push({
          expected: n,
          format: t.format,
          code: "invalid_type",
          continue: !1,
          input: c,
          inst: e
        });
        return;
      }
      if (!Number.isSafeInteger(c)) {
        c > 0 ? s.issues.push({
          input: c,
          code: "too_big",
          maximum: Number.MAX_SAFE_INTEGER,
          note: "Integers must be within the safe integer range.",
          inst: e,
          origin: n,
          inclusive: !0,
          continue: !t.abort
        }) : s.issues.push({
          input: c,
          code: "too_small",
          minimum: Number.MIN_SAFE_INTEGER,
          note: "Integers must be within the safe integer range.",
          inst: e,
          origin: n,
          inclusive: !0,
          continue: !t.abort
        });
        return;
      }
    }
    c < i && s.issues.push({
      origin: "number",
      input: c,
      code: "too_small",
      minimum: i,
      inclusive: !0,
      inst: e,
      continue: !t.abort
    }), c > o && s.issues.push({
      origin: "number",
      input: c,
      code: "too_big",
      maximum: o,
      inclusive: !0,
      inst: e,
      continue: !t.abort
    });
  };
}), $n = /* @__PURE__ */ p("$ZodCheckMaxLength", (e, t) => {
  var r;
  N.init(e, t), (r = e._zod.def).when ?? (r.when = (n) => {
    const i = n.value;
    return !Me(i) && i.length !== void 0;
  }), e._zod.onattach.push((n) => {
    const i = n._zod.bag.maximum ?? Number.POSITIVE_INFINITY;
    t.maximum < i && (n._zod.bag.maximum = t.maximum);
  }), e._zod.check = (n) => {
    const i = n.value;
    if (i.length <= t.maximum) return;
    const o = Be(i);
    n.issues.push({
      origin: o,
      code: "too_big",
      maximum: t.maximum,
      inclusive: !0,
      input: i,
      inst: e,
      continue: !t.abort
    });
  };
}), Tn = /* @__PURE__ */ p("$ZodCheckMinLength", (e, t) => {
  var r;
  N.init(e, t), (r = e._zod.def).when ?? (r.when = (n) => {
    const i = n.value;
    return !Me(i) && i.length !== void 0;
  }), e._zod.onattach.push((n) => {
    const i = n._zod.bag.minimum ?? Number.NEGATIVE_INFINITY;
    t.minimum > i && (n._zod.bag.minimum = t.minimum);
  }), e._zod.check = (n) => {
    const i = n.value;
    if (i.length >= t.minimum) return;
    const o = Be(i);
    n.issues.push({
      origin: o,
      code: "too_small",
      minimum: t.minimum,
      inclusive: !0,
      input: i,
      inst: e,
      continue: !t.abort
    });
  };
}), En = /* @__PURE__ */ p("$ZodCheckLengthEquals", (e, t) => {
  var r;
  N.init(e, t), (r = e._zod.def).when ?? (r.when = (n) => {
    const i = n.value;
    return !Me(i) && i.length !== void 0;
  }), e._zod.onattach.push((n) => {
    const i = n._zod.bag;
    i.minimum = t.length, i.maximum = t.length, i.length = t.length;
  }), e._zod.check = (n) => {
    const i = n.value, o = i.length;
    if (o === t.length) return;
    const s = Be(i), c = o > t.length;
    n.issues.push({
      origin: s,
      ...c ? {
        code: "too_big",
        maximum: t.length
      } : {
        code: "too_small",
        minimum: t.length
      },
      inclusive: !0,
      exact: !0,
      input: n.value,
      inst: e,
      continue: !t.abort
    });
  };
}), be = /* @__PURE__ */ p("$ZodCheckStringFormat", (e, t) => {
  var r, n;
  N.init(e, t), e._zod.onattach.push((i) => {
    const o = i._zod.bag;
    o.format = t.format, t.pattern && (o.patterns ?? (o.patterns = /* @__PURE__ */ new Set()), o.patterns.add(t.pattern));
  }), t.pattern ? (r = e._zod).check ?? (r.check = (i) => {
    t.pattern.lastIndex = 0, !t.pattern.test(i.value) && i.issues.push({
      origin: "string",
      code: "invalid_format",
      format: t.format,
      input: i.value,
      ...t.pattern ? { pattern: t.pattern.toString() } : {},
      inst: e,
      continue: !t.abort
    });
  }) : (n = e._zod).check ?? (n.check = () => {
  });
}), On = /* @__PURE__ */ p("$ZodCheckRegex", (e, t) => {
  be.init(e, t), e._zod.check = (r) => {
    t.pattern.lastIndex = 0, !t.pattern.test(r.value) && r.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "regex",
      input: r.value,
      pattern: t.pattern.toString(),
      inst: e,
      continue: !t.abort
    });
  };
}), jn = /* @__PURE__ */ p("$ZodCheckLowerCase", (e, t) => {
  t.pattern ?? (t.pattern = Sn), be.init(e, t);
}), Zn = /* @__PURE__ */ p("$ZodCheckUpperCase", (e, t) => {
  t.pattern ?? (t.pattern = kn), be.init(e, t);
}), Nn = /* @__PURE__ */ p("$ZodCheckIncludes", (e, t) => {
  N.init(e, t);
  const r = X(t.includes), n = new RegExp(typeof t.position == "number" ? `^.{${t.position}}${r}` : r);
  t.pattern = n, e._zod.onattach.push((i) => {
    const o = i._zod.bag;
    o.patterns ?? (o.patterns = /* @__PURE__ */ new Set()), o.patterns.add(n);
  }), e._zod.check = (i) => {
    i.value.includes(t.includes, t.position) || i.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "includes",
      includes: t.includes,
      input: i.value,
      inst: e,
      continue: !t.abort
    });
  };
}), Cn = /* @__PURE__ */ p("$ZodCheckStartsWith", (e, t) => {
  N.init(e, t);
  const r = new RegExp(`^${X(t.prefix)}.*`);
  t.pattern ?? (t.pattern = r), e._zod.onattach.push((n) => {
    const i = n._zod.bag;
    i.patterns ?? (i.patterns = /* @__PURE__ */ new Set()), i.patterns.add(r);
  }), e._zod.check = (n) => {
    n.value.startsWith(t.prefix) || n.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "starts_with",
      prefix: t.prefix,
      input: n.value,
      inst: e,
      continue: !t.abort
    });
  };
}), An = /* @__PURE__ */ p("$ZodCheckEndsWith", (e, t) => {
  N.init(e, t);
  const r = new RegExp(`.*${X(t.suffix)}$`);
  t.pattern ?? (t.pattern = r), e._zod.onattach.push((n) => {
    const i = n._zod.bag;
    i.patterns ?? (i.patterns = /* @__PURE__ */ new Set()), i.patterns.add(r);
  }), e._zod.check = (n) => {
    n.value.endsWith(t.suffix) || n.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "ends_with",
      suffix: t.suffix,
      input: n.value,
      inst: e,
      continue: !t.abort
    });
  };
}), Rn = /* @__PURE__ */ p("$ZodCheckOverwrite", (e, t) => {
  N.init(e, t), e._zod.check = (r) => {
    r.value = t.tx(r.value);
  };
}), Dn = class {
  constructor(e = []) {
    this.content = [], this.indent = 0, this && (this.args = e);
  }
  indented(e) {
    this.indent += 1, e(this), this.indent -= 1;
  }
  write(e) {
    if (typeof e == "function") {
      e(this, { execution: "sync" }), e(this, { execution: "async" });
      return;
    }
    const t = e.split(`
`).filter((i) => i), r = Math.min(...t.map((i) => i.length - i.trimStart().length)), n = t.map((i) => i.slice(r)).map((i) => " ".repeat(this.indent * 2) + i);
    for (const i of n) this.content.push(i);
  }
  compile() {
    const e = Function, t = this?.args, r = [...(this?.content ?? [""]).map((n) => `  ${n}`)];
    return new e(...t, r.join(`
`));
  }
}, xn = {
  major: 4,
  minor: 4,
  patch: 3
}, k = /* @__PURE__ */ p("$ZodType", (e, t) => {
  var r;
  e ?? (e = {}), e._zod.def = t, e._zod.bag = e._zod.bag || {}, e._zod.version = xn;
  const n = [...e._zod.def.checks ?? []];
  e._zod.traits.has("$ZodCheck") && n.unshift(e);
  for (const i of n) for (const o of i._zod.onattach) o(e);
  if (n.length === 0)
    (r = e._zod).deferred ?? (r.deferred = []), e._zod.deferred?.push(() => {
      e._zod.run = e._zod.parse;
    });
  else {
    const i = (s, c, u) => {
      let d = H(s), h;
      for (const _ of c) {
        if (_._zod.def.when) {
          if (Ur(s) || !_._zod.def.when(s)) continue;
        } else if (d) continue;
        const g = s.issues.length, v = _._zod.check(s);
        if (v instanceof Promise && u?.async === !1) throw new q();
        if (h || v instanceof Promise) h = (h ?? Promise.resolve()).then(async () => {
          await v, s.issues.length !== g && (d || (d = H(s, g)));
        });
        else {
          if (s.issues.length === g) continue;
          d || (d = H(s, g));
        }
      }
      return h ? h.then(() => s) : s;
    }, o = (s, c, u) => {
      if (H(s))
        return s.aborted = !0, s;
      const d = i(c, n, u);
      if (d instanceof Promise) {
        if (u.async === !1) throw new q();
        return d.then((h) => e._zod.parse(h, u));
      }
      return e._zod.parse(d, u);
    };
    e._zod.run = (s, c) => {
      if (c.skipChecks) return e._zod.parse(s, c);
      if (c.direction === "backward") {
        const d = e._zod.parse({
          value: s.value,
          issues: []
        }, {
          ...c,
          skipChecks: !0
        });
        return d instanceof Promise ? d.then((h) => o(h, s, c)) : o(d, s, c);
      }
      const u = e._zod.parse(s, c);
      if (u instanceof Promise) {
        if (c.async === !1) throw new q();
        return u.then((d) => i(d, n, c));
      }
      return i(u, n, c);
    };
  }
  w(e, "~standard", () => ({
    validate: (i) => {
      try {
        const o = Br(e, i);
        return o.success ? { value: o.data } : { issues: o.error?.issues };
      } catch {
        return Fr(e, i).then((s) => s.success ? { value: s.data } : { issues: s.error?.issues });
      }
    },
    vendor: "zod",
    version: 1
  }));
}), Ve = /* @__PURE__ */ p("$ZodString", (e, t) => {
  k.init(e, t), e._zod.pattern = [...e?._zod.bag?.patterns ?? []].pop() ?? _n(e._zod.bag), e._zod.parse = (r, n) => {
    if (t.coerce) try {
      r.value = String(r.value);
    } catch {
    }
    return typeof r.value == "string" || r.issues.push({
      expected: "string",
      code: "invalid_type",
      input: r.value,
      inst: e
    }), r;
  };
}), I = /* @__PURE__ */ p("$ZodStringFormat", (e, t) => {
  be.init(e, t), Ve.init(e, t);
}), Un = /* @__PURE__ */ p("$ZodGUID", (e, t) => {
  t.pattern ?? (t.pattern = sn), I.init(e, t);
}), Mn = /* @__PURE__ */ p("$ZodUUID", (e, t) => {
  if (t.version) {
    const r = {
      v1: 1,
      v2: 2,
      v3: 3,
      v4: 4,
      v5: 5,
      v6: 6,
      v7: 7,
      v8: 8
    }[t.version];
    if (r === void 0) throw new Error(`Invalid UUID version: "${t.version}"`);
    t.pattern ?? (t.pattern = tt(r));
  } else t.pattern ?? (t.pattern = tt());
  I.init(e, t);
}), Ln = /* @__PURE__ */ p("$ZodEmail", (e, t) => {
  t.pattern ?? (t.pattern = an), I.init(e, t);
}), Bn = /* @__PURE__ */ p("$ZodURL", (e, t) => {
  I.init(e, t), e._zod.check = (r) => {
    try {
      const n = r.value.trim();
      if (!t.normalize && t.protocol?.source === fn.source && !/^https?:\/\//i.test(n)) {
        r.issues.push({
          code: "invalid_format",
          format: "url",
          note: "Invalid URL format",
          input: r.value,
          inst: e,
          continue: !t.abort
        });
        return;
      }
      const i = new URL(n);
      t.hostname && (t.hostname.lastIndex = 0, t.hostname.test(i.hostname) || r.issues.push({
        code: "invalid_format",
        format: "url",
        note: "Invalid hostname",
        pattern: t.hostname.source,
        input: r.value,
        inst: e,
        continue: !t.abort
      })), t.protocol && (t.protocol.lastIndex = 0, t.protocol.test(i.protocol.endsWith(":") ? i.protocol.slice(0, -1) : i.protocol) || r.issues.push({
        code: "invalid_format",
        format: "url",
        note: "Invalid protocol",
        pattern: t.protocol.source,
        input: r.value,
        inst: e,
        continue: !t.abort
      })), t.normalize ? r.value = i.href : r.value = n;
      return;
    } catch {
      r.issues.push({
        code: "invalid_format",
        format: "url",
        input: r.value,
        inst: e,
        continue: !t.abort
      });
    }
  };
}), Fn = /* @__PURE__ */ p("$ZodEmoji", (e, t) => {
  t.pattern ?? (t.pattern = un()), I.init(e, t);
}), Jn = /* @__PURE__ */ p("$ZodNanoID", (e, t) => {
  t.pattern ?? (t.pattern = nn), I.init(e, t);
}), Vn = /* @__PURE__ */ p("$ZodCUID", (e, t) => {
  t.pattern ?? (t.pattern = Xr), I.init(e, t);
}), Wn = /* @__PURE__ */ p("$ZodCUID2", (e, t) => {
  t.pattern ?? (t.pattern = Qr), I.init(e, t);
}), Kn = /* @__PURE__ */ p("$ZodULID", (e, t) => {
  t.pattern ?? (t.pattern = en), I.init(e, t);
}), Hn = /* @__PURE__ */ p("$ZodXID", (e, t) => {
  t.pattern ?? (t.pattern = tn), I.init(e, t);
}), Gn = /* @__PURE__ */ p("$ZodKSUID", (e, t) => {
  t.pattern ?? (t.pattern = rn), I.init(e, t);
}), qn = /* @__PURE__ */ p("$ZodISODateTime", (e, t) => {
  t.pattern ?? (t.pattern = yn(t)), I.init(e, t);
}), Yn = /* @__PURE__ */ p("$ZodISODate", (e, t) => {
  t.pattern ?? (t.pattern = vn), I.init(e, t);
}), Xn = /* @__PURE__ */ p("$ZodISOTime", (e, t) => {
  t.pattern ?? (t.pattern = bn(t)), I.init(e, t);
}), Qn = /* @__PURE__ */ p("$ZodISODuration", (e, t) => {
  t.pattern ?? (t.pattern = on), I.init(e, t);
}), ei = /* @__PURE__ */ p("$ZodIPv4", (e, t) => {
  t.pattern ?? (t.pattern = ln), I.init(e, t), e._zod.bag.format = "ipv4";
}), ti = /* @__PURE__ */ p("$ZodIPv6", (e, t) => {
  t.pattern ?? (t.pattern = dn), I.init(e, t), e._zod.bag.format = "ipv6", e._zod.check = (r) => {
    try {
      new URL(`http://[${r.value}]`);
    } catch {
      r.issues.push({
        code: "invalid_format",
        format: "ipv6",
        input: r.value,
        inst: e,
        continue: !t.abort
      });
    }
  };
}), ri = /* @__PURE__ */ p("$ZodCIDRv4", (e, t) => {
  t.pattern ?? (t.pattern = pn), I.init(e, t);
}), ni = /* @__PURE__ */ p("$ZodCIDRv6", (e, t) => {
  t.pattern ?? (t.pattern = hn), I.init(e, t), e._zod.check = (r) => {
    const n = r.value.split("/");
    try {
      if (n.length !== 2) throw new Error();
      const [i, o] = n;
      if (!o) throw new Error();
      const s = Number(o);
      if (`${s}` !== o) throw new Error();
      if (s < 0 || s > 128) throw new Error();
      new URL(`http://[${i}]`);
    } catch {
      r.issues.push({
        code: "invalid_format",
        format: "cidrv6",
        input: r.value,
        inst: e,
        continue: !t.abort
      });
    }
  };
});
function Wt(e) {
  if (e === "") return !0;
  if (/\s/.test(e) || e.length % 4 !== 0) return !1;
  try {
    return atob(e), !0;
  } catch {
    return !1;
  }
}
var ii = /* @__PURE__ */ p("$ZodBase64", (e, t) => {
  t.pattern ?? (t.pattern = mn), I.init(e, t), e._zod.bag.contentEncoding = "base64", e._zod.check = (r) => {
    Wt(r.value) || r.issues.push({
      code: "invalid_format",
      format: "base64",
      input: r.value,
      inst: e,
      continue: !t.abort
    });
  };
});
function oi(e) {
  if (!Ut.test(e)) return !1;
  const t = e.replace(/[-_]/g, (r) => r === "-" ? "+" : "/");
  return Wt(t.padEnd(Math.ceil(t.length / 4) * 4, "="));
}
var si = /* @__PURE__ */ p("$ZodBase64URL", (e, t) => {
  t.pattern ?? (t.pattern = Ut), I.init(e, t), e._zod.bag.contentEncoding = "base64url", e._zod.check = (r) => {
    oi(r.value) || r.issues.push({
      code: "invalid_format",
      format: "base64url",
      input: r.value,
      inst: e,
      continue: !t.abort
    });
  };
}), ai = /* @__PURE__ */ p("$ZodE164", (e, t) => {
  t.pattern ?? (t.pattern = gn), I.init(e, t);
});
function ci(e, t = null) {
  try {
    const r = e.split(".");
    if (r.length !== 3) return !1;
    const [n] = r;
    if (!n) return !1;
    const i = JSON.parse(atob(n));
    return !("typ" in i && i?.typ !== "JWT" || !i.alg || t && (!("alg" in i) || i.alg !== t));
  } catch {
    return !1;
  }
}
var ui = /* @__PURE__ */ p("$ZodJWT", (e, t) => {
  I.init(e, t), e._zod.check = (r) => {
    ci(r.value, t.alg) || r.issues.push({
      code: "invalid_format",
      format: "jwt",
      input: r.value,
      inst: e,
      continue: !t.abort
    });
  };
}), Kt = /* @__PURE__ */ p("$ZodNumber", (e, t) => {
  k.init(e, t), e._zod.pattern = e._zod.bag.pattern ?? Bt, e._zod.parse = (r, n) => {
    if (t.coerce) try {
      r.value = Number(r.value);
    } catch {
    }
    const i = r.value;
    if (typeof i == "number" && !Number.isNaN(i) && Number.isFinite(i)) return r;
    const o = typeof i == "number" ? Number.isNaN(i) ? "NaN" : Number.isFinite(i) ? void 0 : "Infinity" : void 0;
    return r.issues.push({
      expected: "number",
      code: "invalid_type",
      input: i,
      inst: e,
      ...o ? { received: o } : {}
    }), r;
  };
}), li = /* @__PURE__ */ p("$ZodNumberFormat", (e, t) => {
  Pn.init(e, t), Kt.init(e, t);
}), di = /* @__PURE__ */ p("$ZodBoolean", (e, t) => {
  k.init(e, t), e._zod.pattern = In, e._zod.parse = (r, n) => {
    if (t.coerce) try {
      r.value = !!r.value;
    } catch {
    }
    const i = r.value;
    return typeof i == "boolean" || r.issues.push({
      expected: "boolean",
      code: "invalid_type",
      input: i,
      inst: e
    }), r;
  };
}), pi = /* @__PURE__ */ p("$ZodUnknown", (e, t) => {
  k.init(e, t), e._zod.parse = (r) => r;
}), hi = /* @__PURE__ */ p("$ZodNever", (e, t) => {
  k.init(e, t), e._zod.parse = (r, n) => (r.issues.push({
    expected: "never",
    code: "invalid_type",
    input: r.value,
    inst: e
  }), r);
});
function rt(e, t, r) {
  e.issues.length && t.issues.push(...G(r, e.issues)), t.value[r] = e.value;
}
var mi = /* @__PURE__ */ p("$ZodArray", (e, t) => {
  k.init(e, t), e._zod.parse = (r, n) => {
    const i = r.value;
    if (!Array.isArray(i))
      return r.issues.push({
        expected: "array",
        code: "invalid_type",
        input: i,
        inst: e
      }), r;
    r.value = Array(i.length);
    const o = [];
    for (let s = 0; s < i.length; s++) {
      const c = i[s], u = t.element._zod.run({
        value: c,
        issues: []
      }, n);
      u instanceof Promise ? o.push(u.then((d) => rt(d, r, s))) : rt(u, r, s);
    }
    return o.length ? Promise.all(o).then(() => r) : r;
  };
});
function de(e, t, r, n, i, o) {
  const s = r in n;
  if (e.issues.length) {
    if (i && o && !s) return;
    t.issues.push(...G(r, e.issues));
  }
  if (!s && !i) {
    e.issues.length || t.issues.push({
      code: "invalid_type",
      expected: "nonoptional",
      input: void 0,
      path: [r]
    });
    return;
  }
  e.value === void 0 ? s && (t.value[r] = void 0) : t.value[r] = e.value;
}
function Ht(e) {
  const t = Object.keys(e.shape);
  for (const n of t) if (!e.shape?.[n]?._zod?.traits?.has("$ZodType")) throw new Error(`Invalid element at key "${n}": expected a Zod schema`);
  const r = Or(e.shape);
  return {
    ...e,
    keys: t,
    keySet: new Set(t),
    numKeys: t.length,
    optionalKeys: new Set(r)
  };
}
function Gt(e, t, r, n, i, o) {
  const s = [], c = i.keySet, u = i.catchall._zod, d = u.def.type, h = u.optin === "optional", _ = u.optout === "optional";
  for (const g in t) {
    if (g === "__proto__" || c.has(g)) continue;
    if (d === "never") {
      s.push(g);
      continue;
    }
    const v = u.run({
      value: t[g],
      issues: []
    }, n);
    v instanceof Promise ? e.push(v.then((S) => de(S, r, g, t, h, _))) : de(v, r, g, t, h, _);
  }
  return s.length && r.issues.push({
    code: "unrecognized_keys",
    keys: s,
    input: t,
    inst: o
  }), e.length ? Promise.all(e).then(() => r) : r;
}
var fi = /* @__PURE__ */ p("$ZodObject", (e, t) => {
  if (k.init(e, t), !Object.getOwnPropertyDescriptor(t, "shape")?.get) {
    const s = t.shape;
    Object.defineProperty(t, "shape", { get: () => {
      const c = { ...s };
      return Object.defineProperty(t, "shape", { value: c }), c;
    } });
  }
  const r = fe(() => Ht(t));
  w(e._zod, "propValues", () => {
    const s = t.shape, c = {};
    for (const u in s) {
      const d = s[u]._zod;
      if (d.values) {
        c[u] ?? (c[u] = /* @__PURE__ */ new Set());
        for (const h of d.values) c[u].add(h);
      }
    }
    return c;
  });
  const n = re, i = t.catchall;
  let o;
  e._zod.parse = (s, c) => {
    o ?? (o = r.value);
    const u = s.value;
    if (!n(u))
      return s.issues.push({
        expected: "object",
        code: "invalid_type",
        input: u,
        inst: e
      }), s;
    s.value = {};
    const d = [], h = o.shape;
    for (const _ of o.keys) {
      const g = h[_], v = g._zod.optin === "optional", S = g._zod.optout === "optional", E = g._zod.run({
        value: u[_],
        issues: []
      }, c);
      E instanceof Promise ? d.push(E.then((se) => de(se, s, _, u, v, S))) : de(E, s, _, u, v, S);
    }
    return i ? Gt(d, u, s, c, r.value, e) : d.length ? Promise.all(d).then(() => s) : s;
  };
}), gi = /* @__PURE__ */ p("$ZodObjectJIT", (e, t) => {
  fi.init(e, t);
  const r = e._zod.parse, n = fe(() => Ht(t)), i = (g) => {
    const v = new Dn([
      "shape",
      "payload",
      "ctx"
    ]), S = n.value, E = (R) => {
      const $ = et(R);
      return `shape[${$}]._zod.run({ value: input[${$}], issues: [] }, ctx)`;
    };
    v.write("const input = payload.value;");
    const se = /* @__PURE__ */ Object.create(null);
    let Ir = 0;
    for (const R of S.keys) se[R] = `key_${Ir++}`;
    v.write("const newResult = {};");
    for (const R of S.keys) {
      const $ = se[R], O = et(R), qe = g[R], Ye = qe?._zod?.optin === "optional", kr = qe?._zod?.optout === "optional";
      v.write(`const ${$} = ${E(R)};`), Ye && kr ? v.write(`
        if (${$}.issues.length) {
          if (${O} in input) {
            payload.issues = payload.issues.concat(${$}.issues.map(iss => ({
              ...iss,
              path: iss.path ? [${O}, ...iss.path] : [${O}]
            })));
          }
        }
        
        if (${$}.value === undefined) {
          if (${O} in input) {
            newResult[${O}] = undefined;
          }
        } else {
          newResult[${O}] = ${$}.value;
        }
        
      `) : Ye ? v.write(`
        if (${$}.issues.length) {
          payload.issues = payload.issues.concat(${$}.issues.map(iss => ({
            ...iss,
            path: iss.path ? [${O}, ...iss.path] : [${O}]
          })));
        }
        
        if (${$}.value === undefined) {
          if (${O} in input) {
            newResult[${O}] = undefined;
          }
        } else {
          newResult[${O}] = ${$}.value;
        }
        
      `) : v.write(`
        const ${$}_present = ${O} in input;
        if (${$}.issues.length) {
          payload.issues = payload.issues.concat(${$}.issues.map(iss => ({
            ...iss,
            path: iss.path ? [${O}, ...iss.path] : [${O}]
          })));
        }
        if (!${$}_present && !${$}.issues.length) {
          payload.issues.push({
            code: "invalid_type",
            expected: "nonoptional",
            input: undefined,
            path: [${O}]
          });
        }

        if (${$}_present) {
          if (${$}.value === undefined) {
            newResult[${O}] = undefined;
          } else {
            newResult[${O}] = ${$}.value;
          }
        }

      `);
    }
    v.write("payload.value = newResult;"), v.write("return payload;");
    const Sr = v.compile();
    return (R, $) => Sr(g, R, $);
  };
  let o;
  const s = re, c = !le.jitless, d = c && Tr.value, h = t.catchall;
  let _;
  e._zod.parse = (g, v) => {
    _ ?? (_ = n.value);
    const S = g.value;
    return s(S) ? c && d && v?.async === !1 && v.jitless !== !0 ? (o || (o = i(t.shape)), g = o(g, v), h ? Gt([], S, g, v, _, e) : g) : r(g, v) : (g.issues.push({
      expected: "object",
      code: "invalid_type",
      input: S,
      inst: e
    }), g);
  };
});
function nt(e, t, r, n) {
  for (const o of e) if (o.issues.length === 0)
    return t.value = o.value, t;
  const i = e.filter((o) => !H(o));
  return i.length === 1 ? (t.value = i[0].value, i[0]) : (t.issues.push({
    code: "invalid_union",
    input: t.value,
    inst: r,
    errors: e.map((o) => o.issues.map((s) => x(s, n, D())))
  }), t);
}
var qt = /* @__PURE__ */ p("$ZodUnion", (e, t) => {
  k.init(e, t), w(e._zod, "optin", () => t.options.some((n) => n._zod.optin === "optional") ? "optional" : void 0), w(e._zod, "optout", () => t.options.some((n) => n._zod.optout === "optional") ? "optional" : void 0), w(e._zod, "values", () => {
    if (t.options.every((n) => n._zod.values)) return new Set(t.options.flatMap((n) => Array.from(n._zod.values)));
  }), w(e._zod, "pattern", () => {
    if (t.options.every((n) => n._zod.pattern)) {
      const n = t.options.map((i) => i._zod.pattern);
      return new RegExp(`^(${n.map((i) => Le(i.source)).join("|")})$`);
    }
  });
  const r = t.options.length === 1 ? t.options[0]._zod.run : null;
  e._zod.parse = (n, i) => {
    if (r) return r(n, i);
    let o = !1;
    const s = [];
    for (const c of t.options) {
      const u = c._zod.run({
        value: n.value,
        issues: []
      }, i);
      if (u instanceof Promise)
        s.push(u), o = !0;
      else {
        if (u.issues.length === 0) return u;
        s.push(u);
      }
    }
    return o ? Promise.all(s).then((c) => nt(c, n, e, i)) : nt(s, n, e, i);
  };
}), vi = /* @__PURE__ */ p("$ZodDiscriminatedUnion", (e, t) => {
  t.inclusive = !1, qt.init(e, t);
  const r = e._zod.parse;
  w(e._zod, "propValues", () => {
    const i = {};
    for (const o of t.options) {
      const s = o._zod.propValues;
      if (!s || Object.keys(s).length === 0) throw new Error(`Invalid discriminated union option at index "${t.options.indexOf(o)}"`);
      for (const [c, u] of Object.entries(s)) {
        i[c] || (i[c] = /* @__PURE__ */ new Set());
        for (const d of u) i[c].add(d);
      }
    }
    return i;
  });
  const n = fe(() => {
    const i = t.options, o = /* @__PURE__ */ new Map();
    for (const s of i) {
      const c = s._zod.propValues?.[t.discriminator];
      if (!c || c.size === 0) throw new Error(`Invalid discriminated union option at index "${t.options.indexOf(s)}"`);
      for (const u of c) {
        if (o.has(u)) throw new Error(`Duplicate discriminator value "${String(u)}"`);
        o.set(u, s);
      }
    }
    return o;
  });
  e._zod.parse = (i, o) => {
    const s = i.value;
    if (!re(s))
      return i.issues.push({
        code: "invalid_type",
        expected: "object",
        input: s,
        inst: e
      }), i;
    const c = n.value.get(s?.[t.discriminator]);
    return c ? c._zod.run(i, o) : t.unionFallback || o.direction === "backward" ? r(i, o) : (i.issues.push({
      code: "invalid_union",
      errors: [],
      note: "No matching discriminator",
      discriminator: t.discriminator,
      options: Array.from(n.value.keys()),
      input: s,
      path: [t.discriminator],
      inst: e
    }), i);
  };
}), bi = /* @__PURE__ */ p("$ZodIntersection", (e, t) => {
  k.init(e, t), e._zod.parse = (r, n) => {
    const i = r.value, o = t.left._zod.run({
      value: i,
      issues: []
    }, n), s = t.right._zod.run({
      value: i,
      issues: []
    }, n);
    return o instanceof Promise || s instanceof Promise ? Promise.all([o, s]).then(([c, u]) => it(r, c, u)) : it(r, o, s);
  };
});
function je(e, t) {
  if (e === t) return {
    valid: !0,
    data: e
  };
  if (e instanceof Date && t instanceof Date && +e == +t) return {
    valid: !0,
    data: e
  };
  if (Y(e) && Y(t)) {
    const r = Object.keys(t), n = Object.keys(e).filter((o) => r.indexOf(o) !== -1), i = {
      ...e,
      ...t
    };
    for (const o of n) {
      const s = je(e[o], t[o]);
      if (!s.valid) return {
        valid: !1,
        mergeErrorPath: [o, ...s.mergeErrorPath]
      };
      i[o] = s.data;
    }
    return {
      valid: !0,
      data: i
    };
  }
  if (Array.isArray(e) && Array.isArray(t)) {
    if (e.length !== t.length) return {
      valid: !1,
      mergeErrorPath: []
    };
    const r = [];
    for (let n = 0; n < e.length; n++) {
      const i = e[n], o = t[n], s = je(i, o);
      if (!s.valid) return {
        valid: !1,
        mergeErrorPath: [n, ...s.mergeErrorPath]
      };
      r.push(s.data);
    }
    return {
      valid: !0,
      data: r
    };
  }
  return {
    valid: !1,
    mergeErrorPath: []
  };
}
function it(e, t, r) {
  const n = /* @__PURE__ */ new Map();
  let i;
  for (const c of t.issues) if (c.code === "unrecognized_keys") {
    i ?? (i = c);
    for (const u of c.keys)
      n.has(u) || n.set(u, {}), n.get(u).l = !0;
  } else e.issues.push(c);
  for (const c of r.issues) if (c.code === "unrecognized_keys") for (const u of c.keys)
    n.has(u) || n.set(u, {}), n.get(u).r = !0;
  else e.issues.push(c);
  const o = [...n].filter(([, c]) => c.l && c.r).map(([c]) => c);
  if (o.length && i && e.issues.push({
    ...i,
    keys: o
  }), H(e)) return e;
  const s = je(t.value, r.value);
  if (!s.valid) throw new Error(`Unmergable intersection. Error path: ${JSON.stringify(s.mergeErrorPath)}`);
  return e.value = s.data, e;
}
var yi = /* @__PURE__ */ p("$ZodRecord", (e, t) => {
  k.init(e, t), e._zod.parse = (r, n) => {
    const i = r.value;
    if (!Y(i))
      return r.issues.push({
        expected: "record",
        code: "invalid_type",
        input: i,
        inst: e
      }), r;
    const o = [], s = t.keyType._zod.values;
    if (s) {
      r.value = {};
      const c = /* @__PURE__ */ new Set();
      for (const d of s) if (typeof d == "string" || typeof d == "number" || typeof d == "symbol") {
        c.add(typeof d == "number" ? d.toString() : d);
        const h = t.keyType._zod.run({
          value: d,
          issues: []
        }, n);
        if (h instanceof Promise) throw new Error("Async schemas not supported in object keys currently");
        if (h.issues.length) {
          r.issues.push({
            code: "invalid_key",
            origin: "record",
            issues: h.issues.map((v) => x(v, n, D())),
            input: d,
            path: [d],
            inst: e
          });
          continue;
        }
        const _ = h.value, g = t.valueType._zod.run({
          value: i[d],
          issues: []
        }, n);
        g instanceof Promise ? o.push(g.then((v) => {
          v.issues.length && r.issues.push(...G(d, v.issues)), r.value[_] = v.value;
        })) : (g.issues.length && r.issues.push(...G(d, g.issues)), r.value[_] = g.value);
      }
      let u;
      for (const d in i) c.has(d) || (u = u ?? [], u.push(d));
      u && u.length > 0 && r.issues.push({
        code: "unrecognized_keys",
        input: i,
        inst: e,
        keys: u
      });
    } else {
      r.value = {};
      for (const c of Reflect.ownKeys(i)) {
        if (c === "__proto__" || !Object.prototype.propertyIsEnumerable.call(i, c)) continue;
        let u = t.keyType._zod.run({
          value: c,
          issues: []
        }, n);
        if (u instanceof Promise) throw new Error("Async schemas not supported in object keys currently");
        if (typeof c == "string" && Bt.test(c) && u.issues.length) {
          const h = t.keyType._zod.run({
            value: Number(c),
            issues: []
          }, n);
          if (h instanceof Promise) throw new Error("Async schemas not supported in object keys currently");
          h.issues.length === 0 && (u = h);
        }
        if (u.issues.length) {
          t.mode === "loose" ? r.value[c] = i[c] : r.issues.push({
            code: "invalid_key",
            origin: "record",
            issues: u.issues.map((h) => x(h, n, D())),
            input: c,
            path: [c],
            inst: e
          });
          continue;
        }
        const d = t.valueType._zod.run({
          value: i[c],
          issues: []
        }, n);
        d instanceof Promise ? o.push(d.then((h) => {
          h.issues.length && r.issues.push(...G(c, h.issues)), r.value[u.value] = h.value;
        })) : (d.issues.length && r.issues.push(...G(c, d.issues)), r.value[u.value] = d.value);
      }
    }
    return o.length ? Promise.all(o).then(() => r) : r;
  };
}), _i = /* @__PURE__ */ p("$ZodEnum", (e, t) => {
  k.init(e, t);
  const r = Nt(t.entries), n = new Set(r);
  e._zod.values = n, e._zod.pattern = new RegExp(`^(${r.filter((i) => Er.has(typeof i)).map((i) => typeof i == "string" ? X(i) : i.toString()).join("|")})$`), e._zod.parse = (i, o) => {
    const s = i.value;
    return n.has(s) || i.issues.push({
      code: "invalid_value",
      values: r,
      input: s,
      inst: e
    }), i;
  };
}), wi = /* @__PURE__ */ p("$ZodLiteral", (e, t) => {
  if (k.init(e, t), t.values.length === 0) throw new Error("Cannot create literal schema with no valid values");
  const r = new Set(t.values);
  e._zod.values = r, e._zod.pattern = new RegExp(`^(${t.values.map((n) => typeof n == "string" ? X(n) : n ? X(n.toString()) : String(n)).join("|")})$`), e._zod.parse = (n, i) => {
    const o = n.value;
    return r.has(o) || n.issues.push({
      code: "invalid_value",
      values: t.values,
      input: o,
      inst: e
    }), n;
  };
}), Ii = /* @__PURE__ */ p("$ZodTransform", (e, t) => {
  k.init(e, t), e._zod.optin = "optional", e._zod.parse = (r, n) => {
    if (n.direction === "backward") throw new Zt(e.constructor.name);
    const i = t.transform(r.value, r);
    if (n.async) return (i instanceof Promise ? i : Promise.resolve(i)).then((o) => (r.value = o, r.fallback = !0, r));
    if (i instanceof Promise) throw new q();
    return r.value = i, r.fallback = !0, r;
  };
});
function ot(e, t) {
  return t === void 0 && (e.issues.length || e.fallback) ? {
    issues: [],
    value: void 0
  } : e;
}
var Yt = /* @__PURE__ */ p("$ZodOptional", (e, t) => {
  k.init(e, t), e._zod.optin = "optional", e._zod.optout = "optional", w(e._zod, "values", () => t.innerType._zod.values ? /* @__PURE__ */ new Set([...t.innerType._zod.values, void 0]) : void 0), w(e._zod, "pattern", () => {
    const r = t.innerType._zod.pattern;
    return r ? new RegExp(`^(${Le(r.source)})?$`) : void 0;
  }), e._zod.parse = (r, n) => {
    if (t.innerType._zod.optin === "optional") {
      const i = r.value, o = t.innerType._zod.run(r, n);
      return o instanceof Promise ? o.then((s) => ot(s, i)) : ot(o, i);
    }
    return r.value === void 0 ? r : t.innerType._zod.run(r, n);
  };
}), Si = /* @__PURE__ */ p("$ZodExactOptional", (e, t) => {
  Yt.init(e, t), w(e._zod, "values", () => t.innerType._zod.values), w(e._zod, "pattern", () => t.innerType._zod.pattern), e._zod.parse = (r, n) => t.innerType._zod.run(r, n);
}), ki = /* @__PURE__ */ p("$ZodNullable", (e, t) => {
  k.init(e, t), w(e._zod, "optin", () => t.innerType._zod.optin), w(e._zod, "optout", () => t.innerType._zod.optout), w(e._zod, "pattern", () => {
    const r = t.innerType._zod.pattern;
    return r ? new RegExp(`^(${Le(r.source)}|null)$`) : void 0;
  }), w(e._zod, "values", () => t.innerType._zod.values ? /* @__PURE__ */ new Set([...t.innerType._zod.values, null]) : void 0), e._zod.parse = (r, n) => r.value === null ? r : t.innerType._zod.run(r, n);
}), zi = /* @__PURE__ */ p("$ZodDefault", (e, t) => {
  k.init(e, t), e._zod.optin = "optional", w(e._zod, "values", () => t.innerType._zod.values), e._zod.parse = (r, n) => {
    if (n.direction === "backward") return t.innerType._zod.run(r, n);
    if (r.value === void 0)
      return r.value = t.defaultValue, r;
    const i = t.innerType._zod.run(r, n);
    return i instanceof Promise ? i.then((o) => st(o, t)) : st(i, t);
  };
});
function st(e, t) {
  return e.value === void 0 && (e.value = t.defaultValue), e;
}
var Pi = /* @__PURE__ */ p("$ZodPrefault", (e, t) => {
  k.init(e, t), e._zod.optin = "optional", w(e._zod, "values", () => t.innerType._zod.values), e._zod.parse = (r, n) => (n.direction === "backward" || r.value === void 0 && (r.value = t.defaultValue), t.innerType._zod.run(r, n));
}), $i = /* @__PURE__ */ p("$ZodNonOptional", (e, t) => {
  k.init(e, t), w(e._zod, "values", () => {
    const r = t.innerType._zod.values;
    return r ? new Set([...r].filter((n) => n !== void 0)) : void 0;
  }), e._zod.parse = (r, n) => {
    const i = t.innerType._zod.run(r, n);
    return i instanceof Promise ? i.then((o) => at(o, e)) : at(i, e);
  };
});
function at(e, t) {
  return !e.issues.length && e.value === void 0 && e.issues.push({
    code: "invalid_type",
    expected: "nonoptional",
    input: e.value,
    inst: t
  }), e;
}
var Ti = /* @__PURE__ */ p("$ZodCatch", (e, t) => {
  k.init(e, t), e._zod.optin = "optional", w(e._zod, "optout", () => t.innerType._zod.optout), w(e._zod, "values", () => t.innerType._zod.values), e._zod.parse = (r, n) => {
    if (n.direction === "backward") return t.innerType._zod.run(r, n);
    const i = t.innerType._zod.run(r, n);
    return i instanceof Promise ? i.then((o) => (r.value = o.value, o.issues.length && (r.value = t.catchValue({
      ...r,
      error: { issues: o.issues.map((s) => x(s, n, D())) },
      input: r.value
    }), r.issues = [], r.fallback = !0), r)) : (r.value = i.value, i.issues.length && (r.value = t.catchValue({
      ...r,
      error: { issues: i.issues.map((o) => x(o, n, D())) },
      input: r.value
    }), r.issues = [], r.fallback = !0), r);
  };
}), Ei = /* @__PURE__ */ p("$ZodPipe", (e, t) => {
  k.init(e, t), w(e._zod, "values", () => t.in._zod.values), w(e._zod, "optin", () => t.in._zod.optin), w(e._zod, "optout", () => t.out._zod.optout), w(e._zod, "propValues", () => t.in._zod.propValues), e._zod.parse = (r, n) => {
    if (n.direction === "backward") {
      const o = t.out._zod.run(r, n);
      return o instanceof Promise ? o.then((s) => ce(s, t.in, n)) : ce(o, t.in, n);
    }
    const i = t.in._zod.run(r, n);
    return i instanceof Promise ? i.then((o) => ce(o, t.out, n)) : ce(i, t.out, n);
  };
});
function ce(e, t, r) {
  return e.issues.length ? (e.aborted = !0, e) : t._zod.run({
    value: e.value,
    issues: e.issues,
    fallback: e.fallback
  }, r);
}
var Oi = /* @__PURE__ */ p("$ZodReadonly", (e, t) => {
  k.init(e, t), w(e._zod, "propValues", () => t.innerType._zod.propValues), w(e._zod, "values", () => t.innerType._zod.values), w(e._zod, "optin", () => t.innerType?._zod?.optin), w(e._zod, "optout", () => t.innerType?._zod?.optout), e._zod.parse = (r, n) => {
    if (n.direction === "backward") return t.innerType._zod.run(r, n);
    const i = t.innerType._zod.run(r, n);
    return i instanceof Promise ? i.then(ct) : ct(i);
  };
});
function ct(e) {
  return e.value = Object.freeze(e.value), e;
}
var ji = /* @__PURE__ */ p("$ZodCustom", (e, t) => {
  N.init(e, t), k.init(e, t), e._zod.parse = (r, n) => r, e._zod.check = (r) => {
    const n = r.value, i = t.fn(n);
    if (i instanceof Promise) return i.then((o) => ut(o, r, n, e));
    ut(i, r, n, e);
  };
});
function ut(e, t, r, n) {
  if (!e) {
    const i = {
      code: "custom",
      input: r,
      inst: n,
      path: [...n._zod.def.path ?? []],
      continue: !n._zod.def.abort
    };
    n._zod.def.params && (i.params = n._zod.def.params), t.issues.push(ne(i));
  }
}
var lt, Zi = class {
  constructor() {
    this._map = /* @__PURE__ */ new WeakMap(), this._idmap = /* @__PURE__ */ new Map();
  }
  add(e, ...t) {
    const r = t[0];
    return this._map.set(e, r), r && typeof r == "object" && "id" in r && this._idmap.set(r.id, e), this;
  }
  clear() {
    return this._map = /* @__PURE__ */ new WeakMap(), this._idmap = /* @__PURE__ */ new Map(), this;
  }
  remove(e) {
    const t = this._map.get(e);
    return t && typeof t == "object" && "id" in t && this._idmap.delete(t.id), this._map.delete(e), this;
  }
  get(e) {
    const t = e._zod.parent;
    if (t) {
      const r = { ...this.get(t) ?? {} };
      delete r.id;
      const n = {
        ...r,
        ...this._map.get(e)
      };
      return Object.keys(n).length ? n : void 0;
    }
    return this._map.get(e);
  }
  has(e) {
    return this._map.has(e);
  }
};
function Ni() {
  return new Zi();
}
(lt = globalThis).__zod_globalRegistry ?? (lt.__zod_globalRegistry = Ni());
var te = globalThis.__zod_globalRegistry;
// @__NO_SIDE_EFFECTS__
function Ci(e, t) {
  return new e({
    type: "string",
    ...f(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Ai(e, t) {
  return new e({
    type: "string",
    format: "email",
    check: "string_format",
    abort: !1,
    ...f(t)
  });
}
// @__NO_SIDE_EFFECTS__
function dt(e, t) {
  return new e({
    type: "string",
    format: "guid",
    check: "string_format",
    abort: !1,
    ...f(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Ri(e, t) {
  return new e({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    ...f(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Di(e, t) {
  return new e({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    version: "v4",
    ...f(t)
  });
}
// @__NO_SIDE_EFFECTS__
function xi(e, t) {
  return new e({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    version: "v6",
    ...f(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Ui(e, t) {
  return new e({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    version: "v7",
    ...f(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Mi(e, t) {
  return new e({
    type: "string",
    format: "url",
    check: "string_format",
    abort: !1,
    ...f(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Li(e, t) {
  return new e({
    type: "string",
    format: "emoji",
    check: "string_format",
    abort: !1,
    ...f(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Bi(e, t) {
  return new e({
    type: "string",
    format: "nanoid",
    check: "string_format",
    abort: !1,
    ...f(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Fi(e, t) {
  return new e({
    type: "string",
    format: "cuid",
    check: "string_format",
    abort: !1,
    ...f(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Ji(e, t) {
  return new e({
    type: "string",
    format: "cuid2",
    check: "string_format",
    abort: !1,
    ...f(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Vi(e, t) {
  return new e({
    type: "string",
    format: "ulid",
    check: "string_format",
    abort: !1,
    ...f(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Wi(e, t) {
  return new e({
    type: "string",
    format: "xid",
    check: "string_format",
    abort: !1,
    ...f(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Ki(e, t) {
  return new e({
    type: "string",
    format: "ksuid",
    check: "string_format",
    abort: !1,
    ...f(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Hi(e, t) {
  return new e({
    type: "string",
    format: "ipv4",
    check: "string_format",
    abort: !1,
    ...f(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Gi(e, t) {
  return new e({
    type: "string",
    format: "ipv6",
    check: "string_format",
    abort: !1,
    ...f(t)
  });
}
// @__NO_SIDE_EFFECTS__
function qi(e, t) {
  return new e({
    type: "string",
    format: "cidrv4",
    check: "string_format",
    abort: !1,
    ...f(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Yi(e, t) {
  return new e({
    type: "string",
    format: "cidrv6",
    check: "string_format",
    abort: !1,
    ...f(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Xi(e, t) {
  return new e({
    type: "string",
    format: "base64",
    check: "string_format",
    abort: !1,
    ...f(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Qi(e, t) {
  return new e({
    type: "string",
    format: "base64url",
    check: "string_format",
    abort: !1,
    ...f(t)
  });
}
// @__NO_SIDE_EFFECTS__
function eo(e, t) {
  return new e({
    type: "string",
    format: "e164",
    check: "string_format",
    abort: !1,
    ...f(t)
  });
}
// @__NO_SIDE_EFFECTS__
function to(e, t) {
  return new e({
    type: "string",
    format: "jwt",
    check: "string_format",
    abort: !1,
    ...f(t)
  });
}
// @__NO_SIDE_EFFECTS__
function ro(e, t) {
  return new e({
    type: "string",
    format: "datetime",
    check: "string_format",
    offset: !1,
    local: !1,
    precision: null,
    ...f(t)
  });
}
// @__NO_SIDE_EFFECTS__
function no(e, t) {
  return new e({
    type: "string",
    format: "date",
    check: "string_format",
    ...f(t)
  });
}
// @__NO_SIDE_EFFECTS__
function io(e, t) {
  return new e({
    type: "string",
    format: "time",
    check: "string_format",
    precision: null,
    ...f(t)
  });
}
// @__NO_SIDE_EFFECTS__
function oo(e, t) {
  return new e({
    type: "string",
    format: "duration",
    check: "string_format",
    ...f(t)
  });
}
// @__NO_SIDE_EFFECTS__
function so(e, t) {
  return new e({
    type: "number",
    checks: [],
    ...f(t)
  });
}
// @__NO_SIDE_EFFECTS__
function ao(e, t) {
  return new e({
    type: "number",
    check: "number_format",
    abort: !1,
    format: "safeint",
    ...f(t)
  });
}
// @__NO_SIDE_EFFECTS__
function co(e, t) {
  return new e({
    type: "boolean",
    ...f(t)
  });
}
// @__NO_SIDE_EFFECTS__
function uo(e) {
  return new e({ type: "unknown" });
}
// @__NO_SIDE_EFFECTS__
function lo(e, t) {
  return new e({
    type: "never",
    ...f(t)
  });
}
// @__NO_SIDE_EFFECTS__
function pt(e, t) {
  return new Jt({
    check: "less_than",
    ...f(t),
    value: e,
    inclusive: !1
  });
}
// @__NO_SIDE_EFFECTS__
function we(e, t) {
  return new Jt({
    check: "less_than",
    ...f(t),
    value: e,
    inclusive: !0
  });
}
// @__NO_SIDE_EFFECTS__
function ht(e, t) {
  return new Vt({
    check: "greater_than",
    ...f(t),
    value: e,
    inclusive: !1
  });
}
// @__NO_SIDE_EFFECTS__
function Ie(e, t) {
  return new Vt({
    check: "greater_than",
    ...f(t),
    value: e,
    inclusive: !0
  });
}
// @__NO_SIDE_EFFECTS__
function mt(e, t) {
  return new zn({
    check: "multiple_of",
    ...f(t),
    value: e
  });
}
// @__NO_SIDE_EFFECTS__
function Xt(e, t) {
  return new $n({
    check: "max_length",
    ...f(t),
    maximum: e
  });
}
// @__NO_SIDE_EFFECTS__
function pe(e, t) {
  return new Tn({
    check: "min_length",
    ...f(t),
    minimum: e
  });
}
// @__NO_SIDE_EFFECTS__
function Qt(e, t) {
  return new En({
    check: "length_equals",
    ...f(t),
    length: e
  });
}
// @__NO_SIDE_EFFECTS__
function po(e, t) {
  return new On({
    check: "string_format",
    format: "regex",
    ...f(t),
    pattern: e
  });
}
// @__NO_SIDE_EFFECTS__
function ho(e) {
  return new jn({
    check: "string_format",
    format: "lowercase",
    ...f(e)
  });
}
// @__NO_SIDE_EFFECTS__
function mo(e) {
  return new Zn({
    check: "string_format",
    format: "uppercase",
    ...f(e)
  });
}
// @__NO_SIDE_EFFECTS__
function fo(e, t) {
  return new Nn({
    check: "string_format",
    format: "includes",
    ...f(t),
    includes: e
  });
}
// @__NO_SIDE_EFFECTS__
function go(e, t) {
  return new Cn({
    check: "string_format",
    format: "starts_with",
    ...f(t),
    prefix: e
  });
}
// @__NO_SIDE_EFFECTS__
function vo(e, t) {
  return new An({
    check: "string_format",
    format: "ends_with",
    ...f(t),
    suffix: e
  });
}
// @__NO_SIDE_EFFECTS__
function Q(e) {
  return new Rn({
    check: "overwrite",
    tx: e
  });
}
// @__NO_SIDE_EFFECTS__
function bo(e) {
  return /* @__PURE__ */ Q((t) => t.normalize(e));
}
// @__NO_SIDE_EFFECTS__
function yo() {
  return /* @__PURE__ */ Q((e) => e.trim());
}
// @__NO_SIDE_EFFECTS__
function _o() {
  return /* @__PURE__ */ Q((e) => e.toLowerCase());
}
// @__NO_SIDE_EFFECTS__
function wo() {
  return /* @__PURE__ */ Q((e) => e.toUpperCase());
}
// @__NO_SIDE_EFFECTS__
function Io() {
  return /* @__PURE__ */ Q((e) => $r(e));
}
// @__NO_SIDE_EFFECTS__
function So(e, t, r) {
  return new e({
    type: "array",
    element: t,
    ...f(r)
  });
}
// @__NO_SIDE_EFFECTS__
function ko(e, t, r) {
  return new e({
    type: "custom",
    check: "custom",
    fn: t,
    ...f(r)
  });
}
// @__NO_SIDE_EFFECTS__
function zo(e, t) {
  const r = /* @__PURE__ */ Po((n) => (n.addIssue = (i) => {
    if (typeof i == "string") n.issues.push(ne(i, n.value, r._zod.def));
    else {
      const o = i;
      o.fatal && (o.continue = !1), o.code ?? (o.code = "custom"), o.input ?? (o.input = n.value), o.inst ?? (o.inst = r), o.continue ?? (o.continue = !r._zod.def.abort), n.issues.push(ne(o));
    }
  }, e(n.value, n)), t);
  return r;
}
// @__NO_SIDE_EFFECTS__
function Po(e, t) {
  const r = new N({
    check: "custom",
    ...f(t)
  });
  return r._zod.check = e, r;
}
function er(e) {
  let t = e?.target ?? "draft-2020-12";
  return t === "draft-4" && (t = "draft-04"), t === "draft-7" && (t = "draft-07"), {
    processors: e.processors ?? {},
    metadataRegistry: e?.metadata ?? te,
    target: t,
    unrepresentable: e?.unrepresentable ?? "throw",
    override: e?.override ?? (() => {
    }),
    io: e?.io ?? "output",
    counter: 0,
    seen: /* @__PURE__ */ new Map(),
    cycles: e?.cycles ?? "ref",
    reused: e?.reused ?? "inline",
    external: e?.external ?? void 0
  };
}
function T(e, t, r = {
  path: [],
  schemaPath: []
}) {
  var n;
  const i = e._zod.def, o = t.seen.get(e);
  if (o)
    return o.count++, r.schemaPath.includes(e) && (o.cycle = r.path), o.schema;
  const s = {
    schema: {},
    count: 1,
    cycle: void 0,
    path: r.path
  };
  t.seen.set(e, s);
  const c = e._zod.toJSONSchema?.();
  if (c) s.schema = c;
  else {
    const d = {
      ...r,
      schemaPath: [...r.schemaPath, e],
      path: r.path
    };
    if (e._zod.processJSONSchema) e._zod.processJSONSchema(t, s.schema, d);
    else {
      const _ = s.schema, g = t.processors[i.type];
      if (!g) throw new Error(`[toJSONSchema]: Non-representable type encountered: ${i.type}`);
      g(e, t, _, d);
    }
    const h = e._zod.parent;
    h && (s.ref || (s.ref = h), T(h, t, d), t.seen.get(h).isParent = !0);
  }
  const u = t.metadataRegistry.get(e);
  return u && Object.assign(s.schema, u), t.io === "input" && j(e) && (delete s.schema.examples, delete s.schema.default), t.io === "input" && "_prefault" in s.schema && ((n = s.schema).default ?? (n.default = s.schema._prefault)), delete s.schema._prefault, t.seen.get(e).schema;
}
function tr(e, t) {
  const r = e.seen.get(t);
  if (!r) throw new Error("Unprocessed schema. This is a bug in Zod.");
  const n = /* @__PURE__ */ new Map();
  for (const s of e.seen.entries()) {
    const c = e.metadataRegistry.get(s[0])?.id;
    if (c) {
      const u = n.get(c);
      if (u && u !== s[0]) throw new Error(`Duplicate schema id "${c}" detected during JSON Schema conversion. Two different schemas cannot share the same id when converted together.`);
      n.set(c, s[0]);
    }
  }
  const i = (s) => {
    const c = e.target === "draft-2020-12" ? "$defs" : "definitions";
    if (e.external) {
      const h = e.external.registry.get(s[0])?.id, _ = e.external.uri ?? ((v) => v);
      if (h) return { ref: _(h) };
      const g = s[1].defId ?? s[1].schema.id ?? `schema${e.counter++}`;
      return s[1].defId = g, {
        defId: g,
        ref: `${_("__shared")}#/${c}/${g}`
      };
    }
    if (s[1] === r) return { ref: "#" };
    const u = `#/${c}/`, d = s[1].schema.id ?? `__schema${e.counter++}`;
    return {
      defId: d,
      ref: u + d
    };
  }, o = (s) => {
    if (s[1].schema.$ref) return;
    const c = s[1], { ref: u, defId: d } = i(s);
    c.def = { ...c.schema }, d && (c.defId = d);
    const h = c.schema;
    for (const _ in h) delete h[_];
    h.$ref = u;
  };
  if (e.cycles === "throw") for (const s of e.seen.entries()) {
    const c = s[1];
    if (c.cycle) throw new Error(`Cycle detected: #/${c.cycle?.join("/")}/<root>

Set the \`cycles\` parameter to \`"ref"\` to resolve cyclical schemas with defs.`);
  }
  for (const s of e.seen.entries()) {
    const c = s[1];
    if (t === s[0]) {
      o(s);
      continue;
    }
    if (e.external) {
      const u = e.external.registry.get(s[0])?.id;
      if (t !== s[0] && u) {
        o(s);
        continue;
      }
    }
    if (e.metadataRegistry.get(s[0])?.id) {
      o(s);
      continue;
    }
    if (c.cycle) {
      o(s);
      continue;
    }
    if (c.count > 1 && e.reused === "ref") {
      o(s);
      continue;
    }
  }
}
function rr(e, t) {
  const r = e.seen.get(t);
  if (!r) throw new Error("Unprocessed schema. This is a bug in Zod.");
  const n = (c) => {
    const u = e.seen.get(c);
    if (u.ref === null) return;
    const d = u.def ?? u.schema, h = { ...d }, _ = u.ref;
    if (u.ref = null, _) {
      n(_);
      const v = e.seen.get(_), S = v.schema;
      if (S.$ref && (e.target === "draft-07" || e.target === "draft-04" || e.target === "openapi-3.0") ? (d.allOf = d.allOf ?? [], d.allOf.push(S)) : Object.assign(d, S), Object.assign(d, h), c._zod.parent === _) for (const E in d)
        E === "$ref" || E === "allOf" || E in h || delete d[E];
      if (S.$ref && v.def) for (const E in d)
        E === "$ref" || E === "allOf" || E in v.def && JSON.stringify(d[E]) === JSON.stringify(v.def[E]) && delete d[E];
    }
    const g = c._zod.parent;
    if (g && g !== _) {
      n(g);
      const v = e.seen.get(g);
      if (v?.schema.$ref && (d.$ref = v.schema.$ref, v.def))
        for (const S in d)
          S === "$ref" || S === "allOf" || S in v.def && JSON.stringify(d[S]) === JSON.stringify(v.def[S]) && delete d[S];
    }
    e.override({
      zodSchema: c,
      jsonSchema: d,
      path: u.path ?? []
    });
  };
  for (const c of [...e.seen.entries()].reverse()) n(c[0]);
  const i = {};
  if (e.target === "draft-2020-12" ? i.$schema = "https://json-schema.org/draft/2020-12/schema" : e.target === "draft-07" ? i.$schema = "http://json-schema.org/draft-07/schema#" : e.target === "draft-04" ? i.$schema = "http://json-schema.org/draft-04/schema#" : e.target, e.external?.uri) {
    const c = e.external.registry.get(t)?.id;
    if (!c) throw new Error("Schema is missing an `id` property");
    i.$id = e.external.uri(c);
  }
  Object.assign(i, r.def ?? r.schema);
  const o = e.metadataRegistry.get(t)?.id;
  o !== void 0 && i.id === o && delete i.id;
  const s = e.external?.defs ?? {};
  for (const c of e.seen.entries()) {
    const u = c[1];
    u.def && u.defId && (u.def.id === u.defId && delete u.def.id, s[u.defId] = u.def);
  }
  e.external || Object.keys(s).length > 0 && (e.target === "draft-2020-12" ? i.$defs = s : i.definitions = s);
  try {
    const c = JSON.parse(JSON.stringify(i));
    return Object.defineProperty(c, "~standard", {
      value: {
        ...t["~standard"],
        jsonSchema: {
          input: he(t, "input", e.processors),
          output: he(t, "output", e.processors)
        }
      },
      enumerable: !1,
      writable: !1
    }), c;
  } catch {
    throw new Error("Error converting schema to JSON.");
  }
}
function j(e, t) {
  const r = t ?? { seen: /* @__PURE__ */ new Set() };
  if (r.seen.has(e)) return !1;
  r.seen.add(e);
  const n = e._zod.def;
  if (n.type === "transform") return !0;
  if (n.type === "array") return j(n.element, r);
  if (n.type === "set") return j(n.valueType, r);
  if (n.type === "lazy") return j(n.getter(), r);
  if (n.type === "promise" || n.type === "optional" || n.type === "nonoptional" || n.type === "nullable" || n.type === "readonly" || n.type === "default" || n.type === "prefault") return j(n.innerType, r);
  if (n.type === "intersection") return j(n.left, r) || j(n.right, r);
  if (n.type === "record" || n.type === "map") return j(n.keyType, r) || j(n.valueType, r);
  if (n.type === "pipe")
    return e._zod.traits.has("$ZodCodec") ? !0 : j(n.in, r) || j(n.out, r);
  if (n.type === "object") {
    for (const i in n.shape) if (j(n.shape[i], r)) return !0;
    return !1;
  }
  if (n.type === "union") {
    for (const i of n.options) if (j(i, r)) return !0;
    return !1;
  }
  if (n.type === "tuple") {
    for (const i of n.items) if (j(i, r)) return !0;
    return !!(n.rest && j(n.rest, r));
  }
  return !1;
}
var $o = (e, t = {}) => (r) => {
  const n = er({
    ...r,
    processors: t
  });
  return T(e, n), tr(n, e), rr(n, e);
}, he = (e, t, r = {}) => (n) => {
  const { libraryOptions: i, target: o } = n ?? {}, s = er({
    ...i ?? {},
    target: o,
    io: t,
    processors: r
  });
  return T(e, s), tr(s, e), rr(s, e);
}, To = {
  guid: "uuid",
  url: "uri",
  datetime: "date-time",
  json_string: "json-string",
  regex: ""
}, Eo = (e, t, r, n) => {
  const i = r;
  i.type = "string";
  const { minimum: o, maximum: s, format: c, patterns: u, contentEncoding: d } = e._zod.bag;
  if (typeof o == "number" && (i.minLength = o), typeof s == "number" && (i.maxLength = s), c && (i.format = To[c] ?? c, i.format === "" && delete i.format, c === "time" && delete i.format), d && (i.contentEncoding = d), u && u.size > 0) {
    const h = [...u];
    h.length === 1 ? i.pattern = h[0].source : h.length > 1 && (i.allOf = [...h.map((_) => ({
      ...t.target === "draft-07" || t.target === "draft-04" || t.target === "openapi-3.0" ? { type: "string" } : {},
      pattern: _.source
    }))]);
  }
}, Oo = (e, t, r, n) => {
  const i = r, { minimum: o, maximum: s, format: c, multipleOf: u, exclusiveMaximum: d, exclusiveMinimum: h } = e._zod.bag;
  typeof c == "string" && c.includes("int") ? i.type = "integer" : i.type = "number";
  const _ = typeof h == "number" && h >= (o ?? Number.NEGATIVE_INFINITY), g = typeof d == "number" && d <= (s ?? Number.POSITIVE_INFINITY), v = t.target === "draft-04" || t.target === "openapi-3.0";
  _ ? v ? (i.minimum = h, i.exclusiveMinimum = !0) : i.exclusiveMinimum = h : typeof o == "number" && (i.minimum = o), g ? v ? (i.maximum = d, i.exclusiveMaximum = !0) : i.exclusiveMaximum = d : typeof s == "number" && (i.maximum = s), typeof u == "number" && (i.multipleOf = u);
}, jo = (e, t, r, n) => {
  r.type = "boolean";
}, Zo = (e, t, r, n) => {
  r.not = {};
}, No = (e, t, r, n) => {
}, Co = (e, t, r, n) => {
  const i = e._zod.def, o = Nt(i.entries);
  o.every((s) => typeof s == "number") && (r.type = "number"), o.every((s) => typeof s == "string") && (r.type = "string"), r.enum = o;
}, Ao = (e, t, r, n) => {
  const i = e._zod.def, o = [];
  for (const s of i.values) if (s === void 0) {
    if (t.unrepresentable === "throw") throw new Error("Literal `undefined` cannot be represented in JSON Schema");
  } else if (typeof s == "bigint") {
    if (t.unrepresentable === "throw") throw new Error("BigInt literals cannot be represented in JSON Schema");
    o.push(Number(s));
  } else o.push(s);
  if (o.length !== 0)
    if (o.length === 1) {
      const s = o[0];
      r.type = s === null ? "null" : typeof s, t.target === "draft-04" || t.target === "openapi-3.0" ? r.enum = [s] : r.const = s;
    } else
      o.every((s) => typeof s == "number") && (r.type = "number"), o.every((s) => typeof s == "string") && (r.type = "string"), o.every((s) => typeof s == "boolean") && (r.type = "boolean"), o.every((s) => s === null) && (r.type = "null"), r.enum = o;
}, Ro = (e, t, r, n) => {
  if (t.unrepresentable === "throw") throw new Error("Custom types cannot be represented in JSON Schema");
}, Do = (e, t, r, n) => {
  if (t.unrepresentable === "throw") throw new Error("Transforms cannot be represented in JSON Schema");
}, xo = (e, t, r, n) => {
  const i = r, o = e._zod.def, { minimum: s, maximum: c } = e._zod.bag;
  typeof s == "number" && (i.minItems = s), typeof c == "number" && (i.maxItems = c), i.type = "array", i.items = T(o.element, t, {
    ...n,
    path: [...n.path, "items"]
  });
}, Uo = (e, t, r, n) => {
  const i = r, o = e._zod.def;
  i.type = "object", i.properties = {};
  const s = o.shape;
  for (const d in s) i.properties[d] = T(s[d], t, {
    ...n,
    path: [
      ...n.path,
      "properties",
      d
    ]
  });
  const c = new Set(Object.keys(s)), u = new Set([...c].filter((d) => {
    const h = o.shape[d]._zod;
    return t.io === "input" ? h.optin === void 0 : h.optout === void 0;
  }));
  u.size > 0 && (i.required = Array.from(u)), o.catchall?._zod.def.type === "never" ? i.additionalProperties = !1 : o.catchall ? o.catchall && (i.additionalProperties = T(o.catchall, t, {
    ...n,
    path: [...n.path, "additionalProperties"]
  })) : t.io === "output" && (i.additionalProperties = !1);
}, Mo = (e, t, r, n) => {
  const i = e._zod.def, o = i.inclusive === !1, s = i.options.map((c, u) => T(c, t, {
    ...n,
    path: [
      ...n.path,
      o ? "oneOf" : "anyOf",
      u
    ]
  }));
  o ? r.oneOf = s : r.anyOf = s;
}, Lo = (e, t, r, n) => {
  const i = e._zod.def, o = T(i.left, t, {
    ...n,
    path: [
      ...n.path,
      "allOf",
      0
    ]
  }), s = T(i.right, t, {
    ...n,
    path: [
      ...n.path,
      "allOf",
      1
    ]
  }), c = (u) => "allOf" in u && Object.keys(u).length === 1;
  r.allOf = [...c(o) ? o.allOf : [o], ...c(s) ? s.allOf : [s]];
}, Bo = (e, t, r, n) => {
  const i = r, o = e._zod.def;
  i.type = "object";
  const s = o.keyType, c = s._zod.bag?.patterns;
  if (o.mode === "loose" && c && c.size > 0) {
    const d = T(o.valueType, t, {
      ...n,
      path: [
        ...n.path,
        "patternProperties",
        "*"
      ]
    });
    i.patternProperties = {};
    for (const h of c) i.patternProperties[h.source] = d;
  } else
    (t.target === "draft-07" || t.target === "draft-2020-12") && (i.propertyNames = T(o.keyType, t, {
      ...n,
      path: [...n.path, "propertyNames"]
    })), i.additionalProperties = T(o.valueType, t, {
      ...n,
      path: [...n.path, "additionalProperties"]
    });
  const u = s._zod.values;
  if (u) {
    const d = [...u].filter((h) => typeof h == "string" || typeof h == "number");
    d.length > 0 && (i.required = d);
  }
}, Fo = (e, t, r, n) => {
  const i = e._zod.def, o = T(i.innerType, t, n), s = t.seen.get(e);
  t.target === "openapi-3.0" ? (s.ref = i.innerType, r.nullable = !0) : r.anyOf = [o, { type: "null" }];
}, Jo = (e, t, r, n) => {
  const i = e._zod.def;
  T(i.innerType, t, n);
  const o = t.seen.get(e);
  o.ref = i.innerType;
}, Vo = (e, t, r, n) => {
  const i = e._zod.def;
  T(i.innerType, t, n);
  const o = t.seen.get(e);
  o.ref = i.innerType, r.default = JSON.parse(JSON.stringify(i.defaultValue));
}, Wo = (e, t, r, n) => {
  const i = e._zod.def;
  T(i.innerType, t, n);
  const o = t.seen.get(e);
  o.ref = i.innerType, t.io === "input" && (r._prefault = JSON.parse(JSON.stringify(i.defaultValue)));
}, Ko = (e, t, r, n) => {
  const i = e._zod.def;
  T(i.innerType, t, n);
  const o = t.seen.get(e);
  o.ref = i.innerType;
  let s;
  try {
    s = i.catchValue(void 0);
  } catch {
    throw new Error("Dynamic catch values are not supported in JSON Schema");
  }
  r.default = s;
}, Ho = (e, t, r, n) => {
  const i = e._zod.def, o = i.in._zod.traits.has("$ZodTransform"), s = t.io === "input" ? o ? i.out : i.in : i.out;
  T(s, t, n);
  const c = t.seen.get(e);
  c.ref = s;
}, Go = (e, t, r, n) => {
  const i = e._zod.def;
  T(i.innerType, t, n);
  const o = t.seen.get(e);
  o.ref = i.innerType, r.readOnly = !0;
}, nr = (e, t, r, n) => {
  const i = e._zod.def;
  T(i.innerType, t, n);
  const o = t.seen.get(e);
  o.ref = i.innerType;
}, qo = /* @__PURE__ */ p("ZodISODateTime", (e, t) => {
  qn.init(e, t), P.init(e, t);
});
function Yo(e) {
  return /* @__PURE__ */ ro(qo, e);
}
var Xo = /* @__PURE__ */ p("ZodISODate", (e, t) => {
  Yn.init(e, t), P.init(e, t);
});
function Qo(e) {
  return /* @__PURE__ */ no(Xo, e);
}
var es = /* @__PURE__ */ p("ZodISOTime", (e, t) => {
  Xn.init(e, t), P.init(e, t);
});
function ts(e) {
  return /* @__PURE__ */ io(es, e);
}
var rs = /* @__PURE__ */ p("ZodISODuration", (e, t) => {
  Qn.init(e, t), P.init(e, t);
});
function ns(e) {
  return /* @__PURE__ */ oo(rs, e);
}
var is = (e, t) => {
  Dt.init(e, t), e.name = "ZodError", Object.defineProperties(e, {
    format: { value: (r) => Lr(e, r) },
    flatten: { value: (r) => Mr(e, r) },
    addIssue: { value: (r) => {
      e.issues.push(r), e.message = JSON.stringify(e.issues, Oe, 2);
    } },
    addIssues: { value: (r) => {
      e.issues.push(...r), e.message = JSON.stringify(e.issues, Oe, 2);
    } },
    isEmpty: { get() {
      return e.issues.length === 0;
    } }
  });
}, A = /* @__PURE__ */ p("ZodError", is, { Parent: Error }), os = /* @__PURE__ */ Fe(A), ss = /* @__PURE__ */ Je(A), as = /* @__PURE__ */ ge(A), cs = /* @__PURE__ */ ve(A), us = /* @__PURE__ */ Jr(A), ls = /* @__PURE__ */ Vr(A), ds = /* @__PURE__ */ Wr(A), ps = /* @__PURE__ */ Kr(A), hs = /* @__PURE__ */ Hr(A), ms = /* @__PURE__ */ Gr(A), fs = /* @__PURE__ */ qr(A), gs = /* @__PURE__ */ Yr(A), ft = /* @__PURE__ */ new WeakMap();
function oe(e, t, r) {
  const n = Object.getPrototypeOf(e);
  let i = ft.get(n);
  if (i || (i = /* @__PURE__ */ new Set(), ft.set(n, i)), !i.has(t)) {
    i.add(t);
    for (const o in r) {
      const s = r[o];
      Object.defineProperty(n, o, {
        configurable: !0,
        enumerable: !1,
        get() {
          const c = s.bind(this);
          return Object.defineProperty(this, o, {
            configurable: !0,
            writable: !0,
            enumerable: !0,
            value: c
          }), c;
        },
        set(c) {
          Object.defineProperty(this, o, {
            configurable: !0,
            writable: !0,
            enumerable: !0,
            value: c
          });
        }
      });
    }
  }
}
var z = /* @__PURE__ */ p("ZodType", (e, t) => (k.init(e, t), Object.assign(e["~standard"], { jsonSchema: {
  input: he(e, "input"),
  output: he(e, "output")
} }), e.toJSONSchema = $o(e, {}), e.def = t, e.type = t.type, Object.defineProperty(e, "_def", { value: t }), e.parse = (r, n) => os(e, r, n, { callee: e.parse }), e.safeParse = (r, n) => as(e, r, n), e.parseAsync = async (r, n) => ss(e, r, n, { callee: e.parseAsync }), e.safeParseAsync = async (r, n) => cs(e, r, n), e.spa = e.safeParseAsync, e.encode = (r, n) => us(e, r, n), e.decode = (r, n) => ls(e, r, n), e.encodeAsync = async (r, n) => ds(e, r, n), e.decodeAsync = async (r, n) => ps(e, r, n), e.safeEncode = (r, n) => hs(e, r, n), e.safeDecode = (r, n) => ms(e, r, n), e.safeEncodeAsync = async (r, n) => fs(e, r, n), e.safeDecodeAsync = async (r, n) => gs(e, r, n), oe(e, "ZodType", {
  check(...r) {
    const n = this.def;
    return this.clone(L(n, { checks: [...n.checks ?? [], ...r.map((i) => typeof i == "function" ? { _zod: {
      check: i,
      def: { check: "custom" },
      onattach: []
    } } : i)] }), { parent: !0 });
  },
  with(...r) {
    return this.check(...r);
  },
  clone(r, n) {
    return B(this, r, n);
  },
  brand() {
    return this;
  },
  register(r, n) {
    return r.add(this, n), this;
  },
  refine(r, n) {
    return this.check(la(r, n));
  },
  superRefine(r, n) {
    return this.check(da(r, n));
  },
  overwrite(r) {
    return this.check(/* @__PURE__ */ Q(r));
  },
  optional() {
    return yt(this);
  },
  exactOptional() {
    return Ys(this);
  },
  nullable() {
    return _t(this);
  },
  nullish() {
    return yt(_t(this));
  },
  nonoptional(r) {
    return na(this, r);
  },
  array() {
    return C(this);
  },
  or(r) {
    return Bs([this, r]);
  },
  and(r) {
    return Ws(this, r);
  },
  transform(r) {
    return wt(this, Gs(r));
  },
  default(r) {
    return ea(this, r);
  },
  prefault(r) {
    return ra(this, r);
  },
  catch(r) {
    return oa(this, r);
  },
  pipe(r) {
    return wt(this, r);
  },
  readonly() {
    return ca(this);
  },
  describe(r) {
    const n = this.clone();
    return te.add(n, { description: r }), n;
  },
  meta(...r) {
    if (r.length === 0) return te.get(this);
    const n = this.clone();
    return te.add(n, r[0]), n;
  },
  isOptional() {
    return this.safeParse(void 0).success;
  },
  isNullable() {
    return this.safeParse(null).success;
  },
  apply(r) {
    return r(this);
  }
}), Object.defineProperty(e, "description", {
  get() {
    return te.get(e)?.description;
  },
  configurable: !0
}), e)), ir = /* @__PURE__ */ p("_ZodString", (e, t) => {
  Ve.init(e, t), z.init(e, t), e._zod.processJSONSchema = (n, i, o) => Eo(e, n, i, o);
  const r = e._zod.bag;
  e.format = r.format ?? null, e.minLength = r.minimum ?? null, e.maxLength = r.maximum ?? null, oe(e, "_ZodString", {
    regex(...n) {
      return this.check(/* @__PURE__ */ po(...n));
    },
    includes(...n) {
      return this.check(/* @__PURE__ */ fo(...n));
    },
    startsWith(...n) {
      return this.check(/* @__PURE__ */ go(...n));
    },
    endsWith(...n) {
      return this.check(/* @__PURE__ */ vo(...n));
    },
    min(...n) {
      return this.check(/* @__PURE__ */ pe(...n));
    },
    max(...n) {
      return this.check(/* @__PURE__ */ Xt(...n));
    },
    length(...n) {
      return this.check(/* @__PURE__ */ Qt(...n));
    },
    nonempty(...n) {
      return this.check(/* @__PURE__ */ pe(1, ...n));
    },
    lowercase(n) {
      return this.check(/* @__PURE__ */ ho(n));
    },
    uppercase(n) {
      return this.check(/* @__PURE__ */ mo(n));
    },
    trim() {
      return this.check(/* @__PURE__ */ yo());
    },
    normalize(...n) {
      return this.check(/* @__PURE__ */ bo(...n));
    },
    toLowerCase() {
      return this.check(/* @__PURE__ */ _o());
    },
    toUpperCase() {
      return this.check(/* @__PURE__ */ wo());
    },
    slugify() {
      return this.check(/* @__PURE__ */ Io());
    }
  });
}), vs = /* @__PURE__ */ p("ZodString", (e, t) => {
  Ve.init(e, t), ir.init(e, t), e.email = (r) => e.check(/* @__PURE__ */ Ai(bs, r)), e.url = (r) => e.check(/* @__PURE__ */ Mi(ys, r)), e.jwt = (r) => e.check(/* @__PURE__ */ to(Cs, r)), e.emoji = (r) => e.check(/* @__PURE__ */ Li(_s, r)), e.guid = (r) => e.check(/* @__PURE__ */ dt(gt, r)), e.uuid = (r) => e.check(/* @__PURE__ */ Ri(ue, r)), e.uuidv4 = (r) => e.check(/* @__PURE__ */ Di(ue, r)), e.uuidv6 = (r) => e.check(/* @__PURE__ */ xi(ue, r)), e.uuidv7 = (r) => e.check(/* @__PURE__ */ Ui(ue, r)), e.nanoid = (r) => e.check(/* @__PURE__ */ Bi(ws, r)), e.guid = (r) => e.check(/* @__PURE__ */ dt(gt, r)), e.cuid = (r) => e.check(/* @__PURE__ */ Fi(Is, r)), e.cuid2 = (r) => e.check(/* @__PURE__ */ Ji(Ss, r)), e.ulid = (r) => e.check(/* @__PURE__ */ Vi(ks, r)), e.base64 = (r) => e.check(/* @__PURE__ */ Xi(js, r)), e.base64url = (r) => e.check(/* @__PURE__ */ Qi(Zs, r)), e.xid = (r) => e.check(/* @__PURE__ */ Wi(zs, r)), e.ksuid = (r) => e.check(/* @__PURE__ */ Ki(Ps, r)), e.ipv4 = (r) => e.check(/* @__PURE__ */ Hi($s, r)), e.ipv6 = (r) => e.check(/* @__PURE__ */ Gi(Ts, r)), e.cidrv4 = (r) => e.check(/* @__PURE__ */ qi(Es, r)), e.cidrv6 = (r) => e.check(/* @__PURE__ */ Yi(Os, r)), e.e164 = (r) => e.check(/* @__PURE__ */ eo(Ns, r)), e.datetime = (r) => e.check(Yo(r)), e.date = (r) => e.check(Qo(r)), e.time = (r) => e.check(ts(r)), e.duration = (r) => e.check(ns(r));
});
function a(e) {
  return /* @__PURE__ */ Ci(vs, e);
}
var P = /* @__PURE__ */ p("ZodStringFormat", (e, t) => {
  I.init(e, t), ir.init(e, t);
}), bs = /* @__PURE__ */ p("ZodEmail", (e, t) => {
  Ln.init(e, t), P.init(e, t);
}), gt = /* @__PURE__ */ p("ZodGUID", (e, t) => {
  Un.init(e, t), P.init(e, t);
}), ue = /* @__PURE__ */ p("ZodUUID", (e, t) => {
  Mn.init(e, t), P.init(e, t);
}), ys = /* @__PURE__ */ p("ZodURL", (e, t) => {
  Bn.init(e, t), P.init(e, t);
}), _s = /* @__PURE__ */ p("ZodEmoji", (e, t) => {
  Fn.init(e, t), P.init(e, t);
}), ws = /* @__PURE__ */ p("ZodNanoID", (e, t) => {
  Jn.init(e, t), P.init(e, t);
}), Is = /* @__PURE__ */ p("ZodCUID", (e, t) => {
  Vn.init(e, t), P.init(e, t);
}), Ss = /* @__PURE__ */ p("ZodCUID2", (e, t) => {
  Wn.init(e, t), P.init(e, t);
}), ks = /* @__PURE__ */ p("ZodULID", (e, t) => {
  Kn.init(e, t), P.init(e, t);
}), zs = /* @__PURE__ */ p("ZodXID", (e, t) => {
  Hn.init(e, t), P.init(e, t);
}), Ps = /* @__PURE__ */ p("ZodKSUID", (e, t) => {
  Gn.init(e, t), P.init(e, t);
}), $s = /* @__PURE__ */ p("ZodIPv4", (e, t) => {
  ei.init(e, t), P.init(e, t);
}), Ts = /* @__PURE__ */ p("ZodIPv6", (e, t) => {
  ti.init(e, t), P.init(e, t);
}), Es = /* @__PURE__ */ p("ZodCIDRv4", (e, t) => {
  ri.init(e, t), P.init(e, t);
}), Os = /* @__PURE__ */ p("ZodCIDRv6", (e, t) => {
  ni.init(e, t), P.init(e, t);
}), js = /* @__PURE__ */ p("ZodBase64", (e, t) => {
  ii.init(e, t), P.init(e, t);
}), Zs = /* @__PURE__ */ p("ZodBase64URL", (e, t) => {
  si.init(e, t), P.init(e, t);
}), Ns = /* @__PURE__ */ p("ZodE164", (e, t) => {
  ai.init(e, t), P.init(e, t);
}), Cs = /* @__PURE__ */ p("ZodJWT", (e, t) => {
  ui.init(e, t), P.init(e, t);
}), or = /* @__PURE__ */ p("ZodNumber", (e, t) => {
  Kt.init(e, t), z.init(e, t), e._zod.processJSONSchema = (n, i, o) => Oo(e, n, i, o), oe(e, "ZodNumber", {
    gt(n, i) {
      return this.check(/* @__PURE__ */ ht(n, i));
    },
    gte(n, i) {
      return this.check(/* @__PURE__ */ Ie(n, i));
    },
    min(n, i) {
      return this.check(/* @__PURE__ */ Ie(n, i));
    },
    lt(n, i) {
      return this.check(/* @__PURE__ */ pt(n, i));
    },
    lte(n, i) {
      return this.check(/* @__PURE__ */ we(n, i));
    },
    max(n, i) {
      return this.check(/* @__PURE__ */ we(n, i));
    },
    int(n) {
      return this.check(vt(n));
    },
    safe(n) {
      return this.check(vt(n));
    },
    positive(n) {
      return this.check(/* @__PURE__ */ ht(0, n));
    },
    nonnegative(n) {
      return this.check(/* @__PURE__ */ Ie(0, n));
    },
    negative(n) {
      return this.check(/* @__PURE__ */ pt(0, n));
    },
    nonpositive(n) {
      return this.check(/* @__PURE__ */ we(0, n));
    },
    multipleOf(n, i) {
      return this.check(/* @__PURE__ */ mt(n, i));
    },
    step(n, i) {
      return this.check(/* @__PURE__ */ mt(n, i));
    },
    finite() {
      return this;
    }
  });
  const r = e._zod.bag;
  e.minValue = Math.max(r.minimum ?? Number.NEGATIVE_INFINITY, r.exclusiveMinimum ?? Number.NEGATIVE_INFINITY) ?? null, e.maxValue = Math.min(r.maximum ?? Number.POSITIVE_INFINITY, r.exclusiveMaximum ?? Number.POSITIVE_INFINITY) ?? null, e.isInt = (r.format ?? "").includes("int") || Number.isSafeInteger(r.multipleOf ?? 0.5), e.isFinite = !0, e.format = r.format ?? null;
});
function Z(e) {
  return /* @__PURE__ */ so(or, e);
}
var As = /* @__PURE__ */ p("ZodNumberFormat", (e, t) => {
  li.init(e, t), or.init(e, t);
});
function vt(e) {
  return /* @__PURE__ */ ao(As, e);
}
var Rs = /* @__PURE__ */ p("ZodBoolean", (e, t) => {
  di.init(e, t), z.init(e, t), e._zod.processJSONSchema = (r, n, i) => jo(e, r, n, i);
});
function b(e) {
  return /* @__PURE__ */ co(Rs, e);
}
var Ds = /* @__PURE__ */ p("ZodUnknown", (e, t) => {
  pi.init(e, t), z.init(e, t), e._zod.processJSONSchema = (r, n, i) => No(e, r, n, i);
});
function Ze() {
  return /* @__PURE__ */ uo(Ds);
}
var xs = /* @__PURE__ */ p("ZodNever", (e, t) => {
  hi.init(e, t), z.init(e, t), e._zod.processJSONSchema = (r, n, i) => Zo(e, r, n, i);
});
function Us(e) {
  return /* @__PURE__ */ lo(xs, e);
}
var Ms = /* @__PURE__ */ p("ZodArray", (e, t) => {
  mi.init(e, t), z.init(e, t), e._zod.processJSONSchema = (r, n, i) => xo(e, r, n, i), e.element = t.element, oe(e, "ZodArray", {
    min(r, n) {
      return this.check(/* @__PURE__ */ pe(r, n));
    },
    nonempty(r) {
      return this.check(/* @__PURE__ */ pe(1, r));
    },
    max(r, n) {
      return this.check(/* @__PURE__ */ Xt(r, n));
    },
    length(r, n) {
      return this.check(/* @__PURE__ */ Qt(r, n));
    },
    unwrap() {
      return this.element;
    }
  });
});
function C(e, t) {
  return /* @__PURE__ */ So(Ms, e, t);
}
var Ls = /* @__PURE__ */ p("ZodObject", (e, t) => {
  gi.init(e, t), z.init(e, t), e._zod.processJSONSchema = (r, n, i) => Uo(e, r, n, i), w(e, "shape", () => t.shape), oe(e, "ZodObject", {
    keyof() {
      return y(Object.keys(this._zod.def.shape));
    },
    catchall(r) {
      return this.clone({
        ...this._zod.def,
        catchall: r
      });
    },
    passthrough() {
      return this.clone({
        ...this._zod.def,
        catchall: Ze()
      });
    },
    loose() {
      return this.clone({
        ...this._zod.def,
        catchall: Ze()
      });
    },
    strict() {
      return this.clone({
        ...this._zod.def,
        catchall: Us()
      });
    },
    strip() {
      return this.clone({
        ...this._zod.def,
        catchall: void 0
      });
    },
    extend(r) {
      return Cr(this, r);
    },
    safeExtend(r) {
      return Ar(this, r);
    },
    merge(r) {
      return Rr(this, r);
    },
    pick(r) {
      return Zr(this, r);
    },
    omit(r) {
      return Nr(this, r);
    },
    partial(...r) {
      return Dr(ar, this, r[0]);
    },
    required(...r) {
      return xr(cr, this, r[0]);
    }
  });
});
function l(e, t) {
  const r = {
    type: "object",
    shape: e ?? {},
    ...f(t)
  };
  return new Ls(r);
}
var sr = /* @__PURE__ */ p("ZodUnion", (e, t) => {
  qt.init(e, t), z.init(e, t), e._zod.processJSONSchema = (r, n, i) => Mo(e, r, n, i), e.options = t.options;
});
function Bs(e, t) {
  return new sr({
    type: "union",
    options: e,
    ...f(t)
  });
}
var Fs = /* @__PURE__ */ p("ZodDiscriminatedUnion", (e, t) => {
  sr.init(e, t), vi.init(e, t);
});
function Js(e, t, r) {
  return new Fs({
    type: "union",
    options: t,
    discriminator: e,
    ...f(r)
  });
}
var Vs = /* @__PURE__ */ p("ZodIntersection", (e, t) => {
  bi.init(e, t), z.init(e, t), e._zod.processJSONSchema = (r, n, i) => Lo(e, r, n, i);
});
function Ws(e, t) {
  return new Vs({
    type: "intersection",
    left: e,
    right: t
  });
}
var bt = /* @__PURE__ */ p("ZodRecord", (e, t) => {
  yi.init(e, t), z.init(e, t), e._zod.processJSONSchema = (r, n, i) => Bo(e, r, n, i), e.keyType = t.keyType, e.valueType = t.valueType;
});
function ye(e, t, r) {
  return !t || !t._zod ? new bt({
    type: "record",
    keyType: a(),
    valueType: e,
    ...f(t)
  }) : new bt({
    type: "record",
    keyType: e,
    valueType: t,
    ...f(r)
  });
}
var Ne = /* @__PURE__ */ p("ZodEnum", (e, t) => {
  _i.init(e, t), z.init(e, t), e._zod.processJSONSchema = (n, i, o) => Co(e, n, i, o), e.enum = t.entries, e.options = Object.values(t.entries);
  const r = new Set(Object.keys(t.entries));
  e.extract = (n, i) => {
    const o = {};
    for (const s of n) if (r.has(s)) o[s] = t.entries[s];
    else throw new Error(`Key ${s} not found in enum`);
    return new Ne({
      ...t,
      checks: [],
      ...f(i),
      entries: o
    });
  }, e.exclude = (n, i) => {
    const o = { ...t.entries };
    for (const s of n) if (r.has(s)) delete o[s];
    else throw new Error(`Key ${s} not found in enum`);
    return new Ne({
      ...t,
      checks: [],
      ...f(i),
      entries: o
    });
  };
});
function y(e, t) {
  const r = Array.isArray(e) ? Object.fromEntries(e.map((n) => [n, n])) : e;
  return new Ne({
    type: "enum",
    entries: r,
    ...f(t)
  });
}
var Ks = /* @__PURE__ */ p("ZodLiteral", (e, t) => {
  wi.init(e, t), z.init(e, t), e._zod.processJSONSchema = (r, n, i) => Ao(e, r, n, i), e.values = new Set(t.values), Object.defineProperty(e, "value", { get() {
    if (t.values.length > 1) throw new Error("This schema contains multiple valid literal values. Use `.values` instead.");
    return t.values[0];
  } });
});
function M(e, t) {
  return new Ks({
    type: "literal",
    values: Array.isArray(e) ? e : [e],
    ...f(t)
  });
}
var Hs = /* @__PURE__ */ p("ZodTransform", (e, t) => {
  Ii.init(e, t), z.init(e, t), e._zod.processJSONSchema = (r, n, i) => Do(e, r, n, i), e._zod.parse = (r, n) => {
    if (n.direction === "backward") throw new Zt(e.constructor.name);
    r.addIssue = (o) => {
      if (typeof o == "string") r.issues.push(ne(o, r.value, t));
      else {
        const s = o;
        s.fatal && (s.continue = !1), s.code ?? (s.code = "custom"), s.input ?? (s.input = r.value), s.inst ?? (s.inst = e), r.issues.push(ne(s));
      }
    };
    const i = t.transform(r.value, r);
    return i instanceof Promise ? i.then((o) => (r.value = o, r.fallback = !0, r)) : (r.value = i, r.fallback = !0, r);
  };
});
function Gs(e) {
  return new Hs({
    type: "transform",
    transform: e
  });
}
var ar = /* @__PURE__ */ p("ZodOptional", (e, t) => {
  Yt.init(e, t), z.init(e, t), e._zod.processJSONSchema = (r, n, i) => nr(e, r, n, i), e.unwrap = () => e._zod.def.innerType;
});
function yt(e) {
  return new ar({
    type: "optional",
    innerType: e
  });
}
var qs = /* @__PURE__ */ p("ZodExactOptional", (e, t) => {
  Si.init(e, t), z.init(e, t), e._zod.processJSONSchema = (r, n, i) => nr(e, r, n, i), e.unwrap = () => e._zod.def.innerType;
});
function Ys(e) {
  return new qs({
    type: "optional",
    innerType: e
  });
}
var Xs = /* @__PURE__ */ p("ZodNullable", (e, t) => {
  ki.init(e, t), z.init(e, t), e._zod.processJSONSchema = (r, n, i) => Fo(e, r, n, i), e.unwrap = () => e._zod.def.innerType;
});
function _t(e) {
  return new Xs({
    type: "nullable",
    innerType: e
  });
}
var Qs = /* @__PURE__ */ p("ZodDefault", (e, t) => {
  zi.init(e, t), z.init(e, t), e._zod.processJSONSchema = (r, n, i) => Vo(e, r, n, i), e.unwrap = () => e._zod.def.innerType, e.removeDefault = e.unwrap;
});
function ea(e, t) {
  return new Qs({
    type: "default",
    innerType: e,
    get defaultValue() {
      return typeof t == "function" ? t() : At(t);
    }
  });
}
var ta = /* @__PURE__ */ p("ZodPrefault", (e, t) => {
  Pi.init(e, t), z.init(e, t), e._zod.processJSONSchema = (r, n, i) => Wo(e, r, n, i), e.unwrap = () => e._zod.def.innerType;
});
function ra(e, t) {
  return new ta({
    type: "prefault",
    innerType: e,
    get defaultValue() {
      return typeof t == "function" ? t() : At(t);
    }
  });
}
var cr = /* @__PURE__ */ p("ZodNonOptional", (e, t) => {
  $i.init(e, t), z.init(e, t), e._zod.processJSONSchema = (r, n, i) => Jo(e, r, n, i), e.unwrap = () => e._zod.def.innerType;
});
function na(e, t) {
  return new cr({
    type: "nonoptional",
    innerType: e,
    ...f(t)
  });
}
var ia = /* @__PURE__ */ p("ZodCatch", (e, t) => {
  Ti.init(e, t), z.init(e, t), e._zod.processJSONSchema = (r, n, i) => Ko(e, r, n, i), e.unwrap = () => e._zod.def.innerType, e.removeCatch = e.unwrap;
});
function oa(e, t) {
  return new ia({
    type: "catch",
    innerType: e,
    catchValue: typeof t == "function" ? t : () => t
  });
}
var sa = /* @__PURE__ */ p("ZodPipe", (e, t) => {
  Ei.init(e, t), z.init(e, t), e._zod.processJSONSchema = (r, n, i) => Ho(e, r, n, i), e.in = t.in, e.out = t.out;
});
function wt(e, t) {
  return new sa({
    type: "pipe",
    in: e,
    out: t
  });
}
var aa = /* @__PURE__ */ p("ZodReadonly", (e, t) => {
  Oi.init(e, t), z.init(e, t), e._zod.processJSONSchema = (r, n, i) => Go(e, r, n, i), e.unwrap = () => e._zod.def.innerType;
});
function ca(e) {
  return new aa({
    type: "readonly",
    innerType: e
  });
}
var ua = /* @__PURE__ */ p("ZodCustom", (e, t) => {
  ji.init(e, t), z.init(e, t), e._zod.processJSONSchema = (r, n, i) => Ro(e, r, n, i);
});
function la(e, t = {}) {
  return /* @__PURE__ */ ko(ua, e, t);
}
function da(e, t) {
  return /* @__PURE__ */ zo(e, t);
}
var ur = l({
  version: M(1),
  textFragment: a().optional(),
  cssPath: a().optional(),
  xpath: a().optional(),
  containerSelector: a().optional(),
  startOffset: Z().int().nonnegative().optional(),
  endOffset: Z().int().nonnegative().optional(),
  prefix: a().optional(),
  suffix: a().optional(),
  exact: a().optional(),
  elementPicker: b().optional(),
  elementId: a().optional()
}), lr = y(["git", "live"]), ac = y([
  "owner",
  "editor",
  "commenter",
  "viewer"
]), cc = y(["superadmin", "none"]), uc = y(["commit", "content_hash"]), dr = y([
  "open",
  "resolved",
  "misaligned"
]), pa = l({
  stripSelectors: C(a()).optional(),
  collapseWhitespace: b().optional()
}), pr = l({
  homepageUrl: a().url().optional(),
  allowedOrigins: C(a()).optional(),
  oauth: l({
    github: l({
      clientId: a(),
      clientSecret: a()
    }).optional(),
    google: l({
      clientId: a(),
      clientSecret: a()
    }).optional()
  }).optional(),
  branding: l({
    displayName: a().optional(),
    logoUrl: a().url().optional()
  }).optional(),
  appearance: l({ accentColor: a().regex(/^#[0-9a-fA-F]{6}$/).optional() }).optional(),
  policies: l({
    publicRead: b().optional(),
    requireAuthToComment: b().optional(),
    publicComments: b().optional(),
    openEnrollment: b().optional()
  }).optional(),
  ui: l({
    widgetMode: y(["docked", "mini"]).optional(),
    widgetCorner: y([
      "lower-right",
      "lower-left",
      "upper-right",
      "upper-left"
    ]).optional(),
    toolbarPosition: y(["top", "bottom"]).optional(),
    sidebarPosition: y([
      "left",
      "right",
      "top",
      "bottom"
    ]).optional(),
    sidebarSide: y(["left", "right"]).optional(),
    sidebarDisplayMode: y(["flyout", "in-page"]).optional(),
    theme: y(zr).optional(),
    bubblesDefault: b().optional(),
    allowInlineCommenting: b().optional(),
    tooltipDelayMs: Z().int().min(0).max(2e3).optional(),
    bubbleFollowAnimations: b().optional(),
    bubbleZIndex: Z().int().min(0).max(2147483647).optional(),
    signInMode: y([
      "auto",
      "popup",
      "redirect"
    ]).optional()
  }).optional(),
  behavior: l({
    enabled: b().optional(),
    autoDiscover: b().optional(),
    autoDeleteCompletedTasks: b().optional(),
    transport: y([
      "auto",
      "ws",
      "sse",
      "rest"
    ]).optional()
  }).optional(),
  connectedSources: l({
    enabled: b().optional(),
    providers: ye(a(), l({
      enabled: b().optional(),
      allowMembers: b().optional()
    })).optional()
  }).optional(),
  dashboard: l({
    showComments: b().optional(),
    showChanges: b().optional()
  }).optional(),
  repository: l({
    autoSync: b().optional(),
    autoVersion: b().optional(),
    autoCommit: b().optional(),
    commitBranch: a().max(120).optional(),
    commitPath: a().max(240).optional(),
    commitAuthorName: a().max(120).optional(),
    commitAuthorEmail: a().email().max(240).optional()
  }).optional(),
  normalize: pa.optional(),
  notifications: l({
    fromAddress: a().email().optional(),
    smtpUrl: a().optional()
  }).optional(),
  moderation: l({
    profanityFilter: y([
      "off",
      "redact",
      "block"
    ]).optional(),
    extraWords: C(a().min(1).max(80)).max(200).optional()
  }).optional(),
  cleanup: Js("mode", [
    l({ mode: M("off") }),
    l({
      mode: M("older-than"),
      maxAgeHours: Z().int().min(1).max(8760),
      auditOnCleanup: b().optional()
    }),
    l({
      mode: M("keep-newest"),
      limit: Z().int().min(0).max(1e5),
      auditOnCleanup: b().optional()
    }),
    l({
      mode: M("wipe-all-every"),
      intervalHours: Z().int().min(1).max(8760),
      lastWipedAt: a().optional(),
      auditOnCleanup: b().optional()
    })
  ]).optional(),
  chat: l({
    enabled: b().optional(),
    scopes: C(y([
      "org",
      "project",
      "page"
    ])).optional()
  }).optional()
}), lc = l({
  projectId: a(),
  sourceKind: lr,
  sourceId: a(),
  key: a().min(1),
  title: a().nullable().optional()
}), dc = l({
  projectId: a(),
  key: a().min(1)
}), ha = y([
  "lastCommentedAt",
  "createdAt",
  "lastUpdatedAt",
  "commentCount",
  "title"
]), ma = y(["asc", "desc"]), fa = y([
  "all",
  "live",
  "git",
  "managed"
]), pc = l({
  projectId: a(),
  sort: ha.optional(),
  dir: ma.optional(),
  q: a().max(120).optional(),
  source: fa.optional(),
  limit: Z().int().positive().max(200).optional(),
  cursor: a().nullable().optional(),
  includeHidden: b().optional(),
  groupId: a().nullable().optional(),
  hasComments: b().optional(),
  taskType: y([
    "incomplete",
    "complete",
    "all"
  ]).optional()
}), hc = l({
  projectId: a(),
  key: a().min(1),
  title: a().nullable().optional(),
  sourceKind: lr.optional(),
  sourceId: a().optional()
}), ga = y([
  "inherit",
  "public",
  "org",
  "private"
]), mc = l({
  pageId: a(),
  visibility: ga
}), va = y([
  "visible",
  "hidden",
  "disabled"
]), ba = l({
  displayVisibility: va,
  commentingEnabled: b(),
  publicCommentingEnabled: b()
}), ya = ba.partial(), fc = l({
  projectId: a(),
  pageId: a(),
  patch: ya
}), gc = l({
  projectId: a(),
  pageId: a()
}), vc = l({
  projectId: a(),
  pageIds: C(a()).min(1).max(500)
}), bc = l({
  projectId: a(),
  pageId: a()
}), yc = l({
  projectId: a(),
  pageId: a()
}), _c = l({ projectId: a() }), wc = l({
  projectId: a(),
  pageId: a(),
  groupId: a().nullable()
}), Ic = l({ pageId: a().min(1) }), Sc = l({
  sourcePageId: a().min(1),
  hrefs: C(a().min(1)).min(1).max(500)
}), W = y([
  "org",
  "project",
  "page"
]), _a = 4e3, kc = l({
  scope: W,
  scopeId: a().min(1),
  before: a().optional(),
  limit: Z().int().min(1).max(200).optional()
}), zc = l({
  scope: W,
  scopeId: a().min(1),
  body: a().trim().min(1).max(_a),
  guestName: a().trim().min(1).max(60).optional()
}), Pc = l({
  scope: W,
  scopeId: a().min(1)
}), $c = l({
  scope: W,
  scopeId: a().min(1),
  guestName: a().trim().min(1).max(60).optional()
}), Tc = l({
  scope: W,
  scopeId: a().min(1),
  lastReadAt: a().optional()
}), Ec = l({
  scope: W,
  scopeId: a().min(1)
}), Oc = l({
  scope: W,
  scopeId: a().min(1)
}), jc = l({ projectId: a().min(1) }), Zc = l({
  projectId: a(),
  includeTrashed: b().optional()
}), Nc = l({
  projectId: a(),
  name: a().min(1).max(120),
  parentGroupId: a().nullable().optional()
}), Cc = l({
  projectId: a(),
  groupId: a(),
  name: a().min(1).max(120)
}), Ac = l({
  projectId: a(),
  groupId: a(),
  parentGroupId: a().nullable()
}), Rc = l({
  projectId: a(),
  groupId: a(),
  mode: y(["ungroup", "trash-children"])
}), wa = y([
  "read",
  "comment",
  "task"
]), Dc = l({
  pageId: a(),
  permission: wa.default("read"),
  expiresInSeconds: Z().int().positive().max(3600 * 24 * 30 * 3).optional()
}), xc = l({ tokenId: a() }), Uc = l({ pageId: a() }), hr = y([
  "plain",
  "md",
  "rich",
  "media"
]), Ia = y(["original", "processed"]), Mc = l({
  assetId: a(),
  asAttachment: b().optional(),
  variant: Ia.optional()
}), Lc = l({ assetId: a() }), Bc = l({ projectId: a() }), Fc = l({ assetId: a() }), Jc = l({
  projectId: a(),
  title: a().min(1).max(200),
  bodyKind: hr.optional(),
  bodyText: a().max(2e6).optional(),
  repoPath: a().max(1024).nullable().optional(),
  mediaAssetId: a().nullable().optional(),
  groupId: a().nullable().optional()
}), Vc = l({
  docId: a(),
  title: a().min(1).max(200).optional(),
  bodyKind: hr.optional(),
  bodyText: a().max(2e6).optional(),
  repoPath: a().max(1024).nullable().optional(),
  expectedVersion: Z().int().min(1)
}), Wc = l({ docId: a() }), Kc = l({ projectId: a() }), Hc = l({ docId: a() }), Gc = l({
  trackedPageId: a(),
  anchor: ur.nullish(),
  bodyMd: a().min(1).max(1e4),
  versionId: a().nullable().optional(),
  guestName: a().min(1).max(60).optional()
}), qc = l({
  commentId: a(),
  bodyMd: a().min(1).max(1e4).optional(),
  status: dr.optional(),
  anchor: ur.nullish()
}), Yc = l({ commentId: a() }), Xc = l({ commentId: a() }), Sa = a().trim().min(1).max(64), mr = y([
  "comment",
  "reply",
  "chat-message"
]), Qc = l({
  targetKind: mr,
  targetId: a()
}), eu = l({
  targetKind: mr,
  targetId: a(),
  kind: Sa
}), tu = l({ trackedPageId: a() }), ru = l({
  commentId: a(),
  bodyMd: a().min(1).max(1e4),
  guestName: a().min(1).max(60).optional()
}), nu = l({
  replyId: a(),
  bodyMd: a().min(1).max(1e4)
}), iu = l({ replyId: a() }), ka = y(["resolved", "unresolved"]), ou = l({
  trackedPageId: a(),
  status: dr.optional(),
  task: b().optional(),
  taskStatus: ka.optional(),
  commentId: a().optional()
}), su = l({
  commentId: a(),
  isTask: b().optional(),
  resolved: b().optional()
}), au = l({
  projectId: a(),
  pageKey: a().optional()
}), cu = l({
  slug: a().min(1),
  name: a().min(1),
  ownerEmail: a().email(),
  settings: pr.optional()
}), uu = l({
  projectId: a(),
  name: a().min(1).max(120).optional(),
  settings: pr.optional()
}), lu = l({
  projectId: a(),
  targetOrganizationId: a()
}), du = l({ projectId: a() }), pu = l({ projectId: a() }), hu = l({ projectId: a() }), mu = l({ projectId: a() }), fr = y([
  "owner",
  "editor",
  "commenter",
  "viewer"
]), fu = l({ projectId: a() }), gu = l({
  projectId: a(),
  email: a().email(),
  role: fr.default("commenter"),
  sendInvite: b().optional()
}), vu = l({
  projectId: a(),
  userId: a()
}), bu = l({
  projectId: a(),
  userId: a(),
  role: fr
}), yu = l({
  projectId: a(),
  limit: Z().int().positive().max(100).optional()
}), _u = l({
  projectId: a(),
  limit: Z().int().positive().max(100).optional(),
  cursor: a().nullable().optional()
}), gr = y([
  "free",
  "indie",
  "indie_annual",
  "pro",
  "pro_annual",
  "team",
  "team_annual",
  "enterprise",
  "unlimited"
]), wu = y([
  "trialing",
  "active",
  "past_due",
  "cancelled"
]), We = a().min(2).max(40).regex(/^[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/, { message: "lowercase letters, digits, single hyphens (no leading/trailing)" }), vr = y([
  "owner",
  "admin",
  "member"
]), Iu = l({
  name: a().min(1).max(80),
  slug: We.optional(),
  kind: y(["personal", "team"]).default("team")
}), Su = l({
  organizationId: a(),
  name: a().min(1).max(80).optional(),
  slug: We.optional()
}), ku = l({
  organizationId: a(),
  email: a().email(),
  role: vr.default("member")
}), zu = l({
  organizationId: a(),
  userId: a()
}), Pu = l({ organizationId: a() }), $u = l({
  displayName: a().trim().min(1).max(80).nullable().optional(),
  avatarUrl: a().trim().max(2048).nullable().optional()
}), Tu = l({
  organizationId: a(),
  userId: a(),
  role: vr
}), Eu = l({ organizationId: a() }), Ou = l({ organizationId: a() }), ju = l({ token: a().min(1) }), Zu = l({
  organizationName: a().min(1).max(80),
  organizationSlug: We.optional(),
  seedWelcomeProject: b().default(!0)
}), Nu = l({
  email: a().trim().email().max(320),
  password: a().min(8).max(200),
  displayName: a().trim().min(1).max(120).optional()
}), Cu = l({
  email: a().trim().email().max(320),
  password: a().min(1).max(200)
}), Au = l({ userId: a().min(1) }), Ru = l({
  organizationId: a(),
  plan: gr,
  successUrl: a().url(),
  cancelUrl: a().url()
}), Du = l({
  organizationId: a(),
  returnUrl: a().url()
}), xu = l({ organizationId: a() }), Uu = l({ organizationId: a() }), Mu = l({ organizationId: a() }), Lu = l({
  organizationId: a(),
  plan: gr
}), Bu = l({
  organizationId: a(),
  paymentMethodId: a()
}), Fu = l({
  message: a().min(1).max(5e3),
  name: a().max(200).optional(),
  email: a().max(320).optional()
}), Ju = l({
  organizationId: a(),
  limit: Z().int().positive().max(200).optional(),
  before: a().nullable().optional(),
  action: a().min(1).max(80).optional()
}), Vu = l({
  organizationId: a(),
  since: a().nullable().optional(),
  action: a().min(1).max(80).optional()
}), Wu = l({
  template: y([
    "welcome",
    "orgInvite",
    "trialEnding",
    "paymentFailed"
  ]),
  vars: ye(a(), a()).optional()
}), Ku = l({
  repoId: a().min(1),
  path: a().transform((e) => e.replace(/^\/+|\/+$/g, "")).default(""),
  branch: a().optional()
}), Hu = l({ repoId: a().min(1) }), Gu = l({
  repoId: a().min(1),
  path: a().min(1).transform((e) => e.replace(/^\/+|\/+$/g, "")),
  branch: a().optional()
}), za = l({
  path: a().min(1).transform((e) => e.replace(/^\/+|\/+$/g, "")),
  kind: y(["file", "dir"])
}), Pa = l({
  repoId: a().min(1),
  projectId: a().min(1),
  items: C(za).min(1).max(2e3),
  flatten: b().optional(),
  includeExts: C(a().min(1)).optional(),
  excludeExts: C(a().min(1)).optional(),
  excludePaths: C(a().min(1)).optional(),
  excludeNames: C(a().min(1)).optional(),
  branch: a().optional()
}), qu = Pa.extend({
  conflictActions: ye(a(), y([
    "overwrite",
    "skip",
    "rename"
  ])).optional(),
  defaultConflict: y([
    "overwrite",
    "skip",
    "rename"
  ]).optional()
}), Yu = l({
  pageId: a().min(1),
  contentBase64: a().max(50 * 1024 * 1024),
  expectedEtag: a().nullable(),
  commitMessage: a().max(500).optional()
}), Xu = l({ groupId: a().optional() }), Qu = l({
  groupId: a().min(1),
  patch: ye(a(), Ze())
}), el = l({ groupId: a().min(1) }), tl = l({ pageId: a().min(1) }), rl = l({
  endpoint: a().url().min(1),
  keys: l({
    p256dh: a().min(1),
    auth: a().min(1)
  }),
  userAgent: a().max(500).optional()
}), nl = l({ endpoint: a().url().min(1) }), Ke = y([
  "notion",
  "evernote",
  "obsidian",
  "onenote",
  "google-docs"
]), il = l({ provider: Ke.optional() }), ol = l({
  provider: Ke,
  returnUrl: a().optional()
}), sl = l({
  provider: Ke,
  label: a().max(80).optional()
}), al = l({ tokenId: a().min(1) }), cl = l({ integrationId: a().min(1) }), ul = l({
  integrationId: a().min(1),
  cursor: a().optional()
}), ll = l({
  integrationId: a().min(1),
  projectId: a().min(1),
  remoteIds: C(a().min(1)).min(1).max(200)
}), dl = l({ projectId: a().min(1) }), pl = l({ projectId: a().min(1) }), hl = l({ projectId: a().min(1) });
function ie(e) {
  "@babel/helpers - typeof";
  return ie = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, ie(e);
}
function $a(e, t) {
  if (ie(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (ie(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function Ta(e) {
  var t = $a(e, "string");
  return ie(t) == "symbol" ? t : t + "";
}
function m(e, t, r) {
  return (t = Ta(t)) in e ? Object.defineProperty(e, t, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = r, e;
}
var Se = {
  NOT_FOUND: "NOT_FOUND",
  UNAUTHORIZED: "UNAUTHORIZED",
  FORBIDDEN: "FORBIDDEN",
  VALIDATION: "VALIDATION",
  CONFLICT: "CONFLICT",
  PLAN_LIMIT: "PLAN_LIMIT",
  PAYMENT_PROVIDER: "PAYMENT_PROVIDER",
  ORIGIN_NOT_ALLOWED: "ORIGIN_NOT_ALLOWED"
}, ke = class extends Error {
  constructor(e, t, r = 0) {
    super(t), m(this, "code", void 0), m(this, "status", void 0), this.name = "RpcError", this.code = e, this.status = r;
  }
}, K = {
  indie: { usd: 5 },
  pro: { usd: 10 },
  team: { usd: 20 }
}, Ea = 10 / 12;
function ze(e) {
  return `$${Math.round(e * 12 * Ea)} / year`;
}
var ml = {
  free: {
    id: "free",
    name: "Free",
    tagline: "For soloists and small teams getting started.",
    displayPrice: "$0",
    cadence: "monthly",
    currency: "USD",
    limits: {
      maxProjects: 1,
      maxMembers: 5
    },
    features: {
      customBranding: !1,
      emailDigests: !1,
      sso: !1,
      auditLog: !1,
      hidePoweredBy: !1,
      support: "community",
      sla: null
    },
    ctaLabel: "Start free"
  },
  indie: {
    id: "indie",
    name: "Indie",
    tagline: "For solo builders shipping more.",
    displayPrice: `$${K.indie.usd} / month`,
    cadence: "monthly",
    currency: "USD",
    limits: {
      maxProjects: 5,
      maxMembers: 10
    },
    features: {
      customBranding: !0,
      emailDigests: !0,
      sso: !1,
      auditLog: !1,
      hidePoweredBy: !0,
      support: "email",
      sla: null
    },
    ctaLabel: "Start 14-day trial"
  },
  indie_annual: {
    id: "indie_annual",
    name: "Indie (Annual)",
    tagline: "Save ~17% — paid yearly.",
    displayPrice: ze(K.indie.usd),
    cadence: "annual",
    currency: "USD",
    limits: {
      maxProjects: 5,
      maxMembers: 10
    },
    features: {
      customBranding: !0,
      emailDigests: !0,
      sso: !1,
      auditLog: !1,
      hidePoweredBy: !0,
      support: "email",
      sla: null
    },
    ctaLabel: "Start 14-day trial"
  },
  pro: {
    id: "pro",
    name: "Pro",
    tagline: "For growing teams and projects.",
    displayPrice: `$${K.pro.usd} / month`,
    cadence: "monthly",
    currency: "USD",
    limits: {
      maxProjects: 10,
      maxMembers: 15
    },
    features: {
      customBranding: !0,
      emailDigests: !0,
      sso: !1,
      auditLog: !1,
      hidePoweredBy: !0,
      support: "email",
      sla: null
    },
    ctaLabel: "Start 14-day trial",
    popular: !0
  },
  pro_annual: {
    id: "pro_annual",
    name: "Pro (Annual)",
    tagline: "Save ~17% — paid yearly.",
    displayPrice: ze(K.pro.usd),
    cadence: "annual",
    currency: "USD",
    limits: {
      maxProjects: 10,
      maxMembers: 15
    },
    features: {
      customBranding: !0,
      emailDigests: !0,
      sso: !1,
      auditLog: !1,
      hidePoweredBy: !0,
      support: "email",
      sla: null
    },
    ctaLabel: "Start 14-day trial"
  },
  team: {
    id: "team",
    name: "Team",
    tagline: "For companies that need room to grow.",
    displayPrice: `$${K.team.usd} / month`,
    cadence: "monthly",
    currency: "USD",
    limits: {
      maxProjects: null,
      maxMembers: null
    },
    features: {
      customBranding: !0,
      emailDigests: !0,
      sso: !0,
      auditLog: !0,
      hidePoweredBy: !0,
      support: "slack",
      sla: null
    },
    ctaLabel: "Start 14-day trial"
  },
  team_annual: {
    id: "team_annual",
    name: "Team (Annual)",
    tagline: "Save ~17% — paid yearly.",
    displayPrice: ze(K.team.usd),
    cadence: "annual",
    currency: "USD",
    limits: {
      maxProjects: null,
      maxMembers: null
    },
    features: {
      customBranding: !0,
      emailDigests: !0,
      sso: !0,
      auditLog: !0,
      hidePoweredBy: !0,
      support: "slack",
      sla: null
    },
    ctaLabel: "Start 14-day trial"
  },
  enterprise: {
    id: "enterprise",
    name: "Enterprise",
    tagline: "Dedicated capacity, SLA, and priority support.",
    displayPrice: null,
    cadence: "contact",
    currency: null,
    limits: {
      maxProjects: null,
      maxMembers: null
    },
    features: {
      customBranding: !0,
      emailDigests: !0,
      sso: !0,
      auditLog: !0,
      hidePoweredBy: !0,
      support: "csm",
      sla: 99.9
    },
    ctaLabel: "Contact us"
  },
  unlimited: {
    id: "unlimited",
    name: "Internal",
    tagline: "Platform / internal — unlimited, unbilled.",
    displayPrice: null,
    cadence: "contact",
    currency: null,
    limits: {
      maxProjects: null,
      maxMembers: null
    },
    features: {
      customBranding: !0,
      emailDigests: !0,
      sso: !0,
      auditLog: !0,
      hidePoweredBy: !0,
      support: "community",
      sla: null
    },
    ctaLabel: "Contact us"
  }
}, Oa = l({
  version: M(1).default(1),
  theme: a().optional(),
  widgetMode: y(["docked", "mini"]).optional(),
  bubbleColor: a().regex(/^#[0-9a-fA-F]{6}$/, "Must be a #rrggbb hex colour").optional(),
  replyBehavior: y([
    "expand-inline",
    "open-thread",
    "jump-to-page"
  ]).optional()
}), ee = l({
  browser: b().default(!0),
  push: b().default(!0),
  email: b().default(!0),
  sms: b().default(!1)
}), ja = l({
  version: M(1).default(1),
  comments: ee.default({
    browser: !0,
    push: !0,
    email: !0,
    sms: !1
  }),
  replies: ee.default({
    browser: !0,
    push: !0,
    email: !0,
    sms: !1
  }),
  chat: ee.default({
    browser: !0,
    push: !0,
    email: !1,
    sms: !1
  }),
  mentions: ee.default({
    browser: !0,
    push: !0,
    email: !0,
    sms: !1
  }),
  userRegistrations: ee.default({
    browser: !1,
    push: !1,
    email: !0,
    sms: !1
  })
}), Za = l({
  version: M(1).default(1),
  sidebarAutoOpen: b().optional(),
  disableHoverPreview: b().optional()
}), fl = {
  appearance: Oa.parse({}),
  notifications: ja.parse({}),
  widget: Za.parse({})
}, gl = new RegExp("^(?=.{1,253}$)(?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\\.)+[a-z]{2,63}$");
function It(e) {
  if (e && typeof e == "object") {
    const n = e.code;
    if (typeof n == "string" && n.length > 0) return n;
  }
  const t = e instanceof Error ? e.message : typeof e == "string" ? e : "", r = /^([A-Z][A-Z0-9_]+):/.exec(t);
  return r ? r[1] : null;
}
var Na = class {
  constructor() {
    m(this, "listeners", /* @__PURE__ */ new Map());
  }
  on(e, t) {
    const r = this.listeners.get(e) ?? /* @__PURE__ */ new Set();
    return r.add(t), this.listeners.set(e, r), () => r.delete(t);
  }
  emit(e, t) {
    const r = this.listeners.get(e);
    if (r)
      for (const n of r) try {
        n(t);
      } catch {
      }
  }
}, Ca = [
  "projects.updated",
  "memberships.updated",
  "comments.created",
  "comments.updated",
  "comments.deleted",
  "comments.bulkDeleted",
  "replies.created",
  "replies.updated",
  "replies.deleted",
  "reactions.changed",
  "versions.refreshed",
  "repo.sync.started",
  "repo.sync.finished",
  "repo.sync.failed",
  "integration.sync.started",
  "integration.sync.finished",
  "integration.sync.failed",
  "notifications.new",
  "media.processed",
  "pages.changed",
  "pageGroups.changed",
  "managedDocs.changed",
  "chat.message",
  "chat.presence",
  "chat.read",
  "chat.typing",
  "notification.show",
  "user.registered",
  "org.member.joined"
], He = class Ce {
  constructor(t, r) {
    m(this, "config", void 0), m(this, "bus", void 0), m(this, "socket", null), m(this, "sse", null), m(this, "nextId", 1), m(this, "pending", /* @__PURE__ */ new Map()), m(this, "connected", !1), m(this, "currentTransport", null), m(this, "desiredTopics", /* @__PURE__ */ new Set()), m(this, "pendingTopicAcks", /* @__PURE__ */ new Map()), m(this, "topicExtras", /* @__PURE__ */ new Map()), m(this, "intentionalClose", !1), m(this, "reconnectAttempts", 0), m(this, "reconnectTimer", null), this.config = t, this.bus = r;
  }
  getEndpoint() {
    return this.config.endpoint;
  }
  replayConnectionState() {
    this.connected && this.currentTransport ? this.bus.emit("connection:open", { transport: this.currentTransport }) : this.bus.emit("connection:closed", {});
  }
  setToken(t) {
    this.config.token = t, this.disconnect(), this.connect();
  }
  getToken() {
    return this.config.token;
  }
  async connect() {
    this.intentionalClose = !1, this.reconnectTimer && (clearTimeout(this.reconnectTimer), this.reconnectTimer = null);
    const t = this.config.transport ?? "auto";
    if (t === "ws" || t === "auto") try {
      await this.connectWs();
      return;
    } catch {
      if (t === "ws") throw new Error("WebSocket connect failed");
    }
    if (t === "sse" || t === "auto") try {
      this.connectSse();
      return;
    } catch {
    }
    this.connected = !0, this.currentTransport = "rest", this.bus.emit("connection:open", { transport: "rest" });
  }
  disconnect() {
    this.intentionalClose = !0, this.reconnectTimer && (clearTimeout(this.reconnectTimer), this.reconnectTimer = null), this.socket && (this.socket.close(), this.socket = null), this.sse && (this.sse.close(), this.sse = null), this.connected = !1;
  }
  retryNow() {
    this.intentionalClose || this.socket && this.socket.readyState === this.socket.OPEN || (this.reconnectTimer && (clearTimeout(this.reconnectTimer), this.reconnectTimer = null), this.reconnectAttempts = 0, this.connect());
  }
  scheduleReconnect() {
    if (this.intentionalClose || this.config.transport && this.config.transport !== "auto" && this.config.transport !== "ws" || this.reconnectTimer) return;
    const t = this.reconnectAttempts + 1, r = Ce.RECONNECT_BASE_MS * 2 ** (t - 1), n = Math.min(r, Ce.RECONNECT_MAX_MS), i = Math.round(n / 2 + Math.random() * (n / 2));
    this.bus.emit("connection:reconnecting", {
      attempt: t,
      delayMs: i
    }), this.reconnectTimer = setTimeout(() => {
      this.reconnectTimer = null, this.reconnectAttempts = t, this.connect().catch(() => {
        this.scheduleReconnect();
      });
    }, i);
  }
  async call(t, r) {
    return this.socket && this.socket.readyState === this.socket.OPEN ? this.callWs(t, r) : this.callRest(t, r);
  }
  async subscribeTopic(t, r) {
    if (!t) throw new Error("subscribeTopic: empty topic");
    return this.desiredTopics.add(t), r ? this.topicExtras.set(t, r) : this.topicExtras.delete(t), this.socket && this.socket.readyState === this.socket.OPEN ? this.sendSubscribeFrame(t) : this.queueTopicAck(t, 3e4);
  }
  unsubscribeTopic(t) {
    this.desiredTopics.delete(t), this.socket && this.socket.readyState === this.socket.OPEN && this.socket.send(JSON.stringify({
      type: "unsubscribe",
      topic: t
    }));
    const r = this.pendingTopicAcks.get(t);
    if (r) {
      this.pendingTopicAcks.delete(t);
      for (const n of r)
        clearTimeout(n.timer), n.reject(/* @__PURE__ */ new Error(`unsubscribed before ack: ${t}`));
    }
  }
  connectWs() {
    return new Promise((t, r) => {
      const n = this.config.endpoint.replace(/^http/, "ws") + `/ws?projectId=${encodeURIComponent(this.config.projectId)}` + (this.config.token ? `&token=${encodeURIComponent(this.config.token)}` : ""), i = new WebSocket(n), o = setTimeout(() => {
        i.close(), r(/* @__PURE__ */ new Error("WS connect timeout"));
      }, 4e3);
      i.onopen = () => {
        clearTimeout(o), this.socket = i, this.connected = !0, this.currentTransport = "ws", this.reconnectAttempts = 0, this.bus.emit("connection:open", { transport: "ws" });
        for (const s of this.desiredTopics) this.sendSubscribeFrame(s).catch(() => {
        });
        t();
      }, i.onerror = () => {
        clearTimeout(o), r(/* @__PURE__ */ new Error("WS connect error"));
      }, i.onclose = () => {
        this.connected = !1, this.socket === i && (this.socket = null), this.bus.emit("connection:closed", { transport: "ws" });
        for (const [s, c] of this.pendingTopicAcks) for (const u of c)
          clearTimeout(u.timer), u.timer = this.armAckTimer(s, 6e4, u.reject);
        this.scheduleReconnect();
      }, i.onmessage = (s) => this.handleWsMessage(s.data);
    });
  }
  callWs(t, r) {
    return new Promise((n, i) => {
      const o = String(this.nextId++);
      this.pending.set(o, {
        resolve: n,
        reject: i
      }), this.socket.send(JSON.stringify({
        type: "request",
        id: o,
        method: t,
        params: r
      })), setTimeout(() => {
        this.pending.has(o) && (this.pending.delete(o), i(/* @__PURE__ */ new Error(`Request timeout: ${t}`)));
      }, 3e4);
    });
  }
  sendSubscribeFrame(t) {
    return new Promise((r, n) => {
      const i = this.armAckTimer(t, 8e3, n), o = this.pendingTopicAcks.get(t) ?? [];
      o.push({
        resolve: r,
        reject: n,
        timer: i
      }), this.pendingTopicAcks.set(t, o);
      const s = this.topicExtras.get(t);
      this.socket.send(JSON.stringify({
        type: "subscribe",
        topic: t,
        ...s ?? {}
      }));
    });
  }
  queueTopicAck(t, r) {
    return new Promise((n, i) => {
      const o = this.armAckTimer(t, r, i), s = this.pendingTopicAcks.get(t) ?? [];
      s.push({
        resolve: n,
        reject: i,
        timer: o
      }), this.pendingTopicAcks.set(t, s);
    });
  }
  armAckTimer(t, r, n) {
    const i = setTimeout(() => {
      const o = this.pendingTopicAcks.get(t);
      if (!o) return;
      const s = o.findIndex((c) => c.timer === i);
      s >= 0 && (o.splice(s, 1), o.length === 0 && this.pendingTopicAcks.delete(t)), n(/* @__PURE__ */ new Error(`subscribe timeout: ${t}`));
    }, r);
    return i;
  }
  resolveTopicAck(t, r, n) {
    const i = this.pendingTopicAcks.get(t);
    if (i) {
      this.pendingTopicAcks.delete(t);
      for (const o of i)
        clearTimeout(o.timer), r ? o.resolve() : o.reject(new ke(n?.code ?? "FORBIDDEN", n?.message ?? "subscribe denied"));
    }
  }
  handleWsMessage(t) {
    let r;
    try {
      r = JSON.parse(typeof t == "string" ? t : t.toString());
    } catch {
      return;
    }
    if (r.type === "response") {
      const n = this.pending.get(r.id);
      if (!n) return;
      this.pending.delete(r.id), r.error ? n.reject(new ke(r.error.code, r.error.message)) : n.resolve(r.result);
      return;
    }
    if (r.type === "subscribed") {
      this.resolveTopicAck(r.topic, !!r.ok, r.error), r.ok || this.desiredTopics.delete(r.topic);
      return;
    }
    if (r.type !== "unsubscribed" && r.type === "event") {
      const n = r.event;
      this.bus.emit(n.name, n);
    }
  }
  connectSse() {
    const t = `${this.config.endpoint}/api/v1/events?projectId=${encodeURIComponent(this.config.projectId)}`;
    this.sse = new EventSource(t, { withCredentials: !0 }), this.sse.onopen = () => {
      this.connected = !0, this.currentTransport = "sse", this.bus.emit("connection:open", { transport: "sse" });
    }, this.sse.onerror = () => {
      this.connected = !1, this.bus.emit("connection:closed", { transport: "sse" });
    };
    const r = (n) => {
      try {
        const i = JSON.parse(n.data);
        this.bus.emit(i.name, i);
      } catch {
      }
    };
    for (const n of Ca) this.sse.addEventListener(n, (i) => r(i));
    this.sse.onmessage = (n) => r(n);
  }
  async callRest(t, r) {
    const n = {
      "content-type": "application/json",
      "x-pageloop-project": this.config.projectId
    };
    this.config.token && (n.authorization = `Bearer ${this.config.token}`);
    const i = await fetch(`${this.config.endpoint}/api/v1/rpc`, {
      method: "POST",
      headers: n,
      body: JSON.stringify({
        method: t,
        params: r,
        projectId: this.config.projectId
      })
    }), o = await i.json();
    if (!i.ok || o.error) throw new ke(o.error?.code ?? "HTTP", o.error?.message ?? i.statusText, i.status);
    return o.result;
  }
};
m(He, "RECONNECT_BASE_MS", 1e3);
m(He, "RECONNECT_MAX_MS", 3e4);
var Aa = class {
  constructor(e, t) {
    m(this, "api", void 0), m(this, "bus", void 0), m(this, "byPage", /* @__PURE__ */ new Map()), m(this, "repliesByComment", /* @__PURE__ */ new Map()), m(this, "reactionsByTarget", /* @__PURE__ */ new Map()), this.api = e, this.bus = t, t.on("comments.created", (r) => {
      const n = r.comment, i = this.byPage.get(n.trackedPageId) ?? [];
      i.find((o) => o.id === n.id) || i.push(n), this.byPage.set(n.trackedPageId, i), this.bus.emit("comment:created", n);
    }), t.on("comments.updated", (r) => {
      const n = r.comment, i = this.byPage.get(n.trackedPageId) ?? [], o = i.findIndex((s) => s.id === n.id);
      o >= 0 && (i[o] = n), this.byPage.set(n.trackedPageId, i), this.bus.emit("comment:updated", n);
    }), t.on("comments.deleted", (r) => {
      const n = (this.byPage.get(r.trackedPageId) ?? []).filter((i) => i.id !== r.commentId);
      this.byPage.set(r.trackedPageId, n), this.repliesByComment.delete(r.commentId), this.reactionsByTarget.delete(`comment:${r.commentId}`), this.bus.emit("comment:deleted", { id: r.commentId });
    }), t.on("comments.bulkDeleted", (r) => {
      this.byPage.set(r.trackedPageId, []), this.bus.emit("comment:bulkDeleted", r);
    }), t.on("replies.created", (r) => {
      const n = r.reply, i = this.repliesByComment.get(n.commentId) ?? [];
      i.find((o) => o.id === n.id) || i.push(n), this.repliesByComment.set(n.commentId, i), this.bus.emit("reply:created", n);
    }), t.on("replies.updated", (r) => {
      const n = r.reply, i = this.repliesByComment.get(n.commentId);
      if (i) {
        const o = i.findIndex((s) => s.id === n.id);
        o >= 0 && (i[o] = n), this.repliesByComment.set(n.commentId, i);
      }
      this.bus.emit("reply:updated", n);
    }), t.on("replies.deleted", (r) => {
      const n = this.repliesByComment.get(r.commentId);
      n && this.repliesByComment.set(r.commentId, n.filter((i) => i.id !== r.replyId)), this.bus.emit("reply:deleted", {
        id: r.replyId,
        commentId: r.commentId
      });
    }), t.on("reactions.changed", (r) => {
      this.reactionsByTarget.set(`${r.targetKind}:${r.targetId}`, r.reactions), this.bus.emit("reaction:changed", r);
    });
  }
  load(e) {
    return this.byPage.get(e) ?? [];
  }
  async loadFromServer(e) {
    const t = await this.api.call("comments.list", { trackedPageId: e });
    return this.byPage.set(e, t), this.bus.emit("comments:loaded", {
      pageId: e,
      comments: t
    }), t;
  }
  async create(e) {
    const t = await this.api.call("comments.create", e);
    return this.applyLocalCreate(t), t;
  }
  applyLocalCreate(e) {
    const t = this.byPage.get(e.trackedPageId) ?? [];
    t.find((r) => r.id === e.id) || (t.push(e), this.byPage.set(e.trackedPageId, t)), this.bus.emit("comment:created", e);
  }
  async update(e) {
    const t = await this.api.call("comments.update", e);
    return this.applyLocalUpdate(t), t;
  }
  async setTask(e) {
    const t = await this.api.call("comments.setTask", e);
    return this.applyLocalUpdate(t), t;
  }
  applyLocalUpdate(e) {
    const t = this.byPage.get(e.trackedPageId) ?? [], r = t.findIndex((n) => n.id === e.id);
    r >= 0 ? t[r] = e : t.push(e), this.byPage.set(e.trackedPageId, t), this.bus.emit("comment:updated", e);
  }
  async delete(e) {
    await this.api.call("comments.delete", { commentId: e }), this.applyLocalDelete(e);
  }
  applyLocalDelete(e) {
    let t = null;
    for (const [r, n] of this.byPage) if (n.some((i) => i.id === e)) {
      t = r, this.byPage.set(r, n.filter((i) => i.id !== e));
      break;
    }
    this.repliesByComment.delete(e), this.reactionsByTarget.delete(`comment:${e}`), this.bus.emit("comment:deleted", {
      id: e,
      trackedPageId: t
    });
  }
  async reply(e, t, r) {
    const n = await this.api.call("replies.create", {
      commentId: e,
      bodyMd: t,
      guestName: r
    });
    return this.applyLocalReplyCreate(n), n;
  }
  async updateReply(e, t) {
    const r = await this.api.call("replies.update", {
      replyId: e,
      bodyMd: t
    });
    return this.applyLocalReplyUpdate(r), r;
  }
  async deleteReply(e) {
    await this.api.call("replies.delete", { replyId: e }), this.applyLocalReplyDelete(e);
  }
  applyLocalReplyCreate(e) {
    const t = this.repliesByComment.get(e.commentId);
    t && (t.find((r) => r.id === e.id) || t.push(e), this.repliesByComment.set(e.commentId, t)), this.bus.emit("reply:created", e);
  }
  applyLocalReplyUpdate(e) {
    const t = this.repliesByComment.get(e.commentId);
    if (t) {
      const r = t.findIndex((n) => n.id === e.id);
      r >= 0 && (t[r] = e), this.repliesByComment.set(e.commentId, t);
    }
    this.bus.emit("reply:updated", e);
  }
  applyLocalReplyDelete(e) {
    let t = null;
    for (const [r, n] of this.repliesByComment) if (n.some((i) => i.id === e)) {
      t = r, this.repliesByComment.set(r, n.filter((i) => i.id !== e));
      break;
    }
    this.bus.emit("reply:deleted", {
      id: e,
      commentId: t
    });
  }
  loadedReplies(e) {
    return this.repliesByComment.get(e) ?? null;
  }
  async fetchReplies(e) {
    const t = await this.api.call("replies.list", { commentId: e });
    return this.repliesByComment.set(e, t), t;
  }
  loadedReactions(e, t) {
    return this.reactionsByTarget.get(`${e}:${t}`) ?? [];
  }
  async fetchReactions(e, t) {
    const r = await this.api.call("reactions.list", {
      targetKind: e,
      targetId: t
    });
    return this.reactionsByTarget.set(`${e}:${t}`, r), r;
  }
  async toggleReaction(e, t, r) {
    const n = await this.api.call("reactions.toggle", {
      targetKind: e,
      targetId: t,
      kind: r
    });
    return this.reactionsByTarget.set(`${e}:${t}`, n.reactions), this.bus.emit("reaction:changed", {
      targetKind: e,
      targetId: t,
      reactions: n.reactions
    }), n.reactions;
  }
  async bulkDeleteForPage(e) {
    const t = await this.api.call("comments.bulkDelete", { trackedPageId: e });
    return this.byPage.set(e, []), this.bus.emit("comment:bulkDeleted", {
      trackedPageId: e,
      deleted: t.deleted
    }), t;
  }
  prime(e, t) {
    this.byPage.set(e, t);
  }
}, Ra = class {
  constructor(e) {
    m(this, "bus", void 0), m(this, "currentUrl", null), m(this, "offHandlers", []), this.bus = e;
  }
  start() {
    this.maybeEmit();
    const e = () => this.maybeEmit();
    window.addEventListener("popstate", e), window.addEventListener("hashchange", e);
    const t = history.pushState, r = history.replaceState;
    history.pushState = function(...n) {
      t.apply(this, n), e();
    }, history.replaceState = function(...n) {
      r.apply(this, n), e();
    }, this.offHandlers = [
      () => window.removeEventListener("popstate", e),
      () => window.removeEventListener("hashchange", e),
      () => {
        history.pushState = t, history.replaceState = r;
      }
    ];
  }
  stop() {
    for (const e of this.offHandlers) e();
    this.offHandlers = [];
  }
  pageKey() {
    const e = document.querySelector('meta[name="pageloop:page-key"]')?.getAttribute("content")?.trim();
    return e || xa(window.location.href);
  }
  maybeEmit() {
    const e = this.pageKey();
    e !== this.currentUrl && (this.currentUrl = e, this.bus.emit("page:change", {
      url: window.location.href,
      key: e
    }));
  }
}, Da = /* @__PURE__ */ new Set([
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_term",
  "utm_content",
  "gclid",
  "fbclid",
  "mc_cid",
  "mc_eid",
  "pageloop-debug"
]);
function xa(e) {
  try {
    const t = new URL(e);
    t.host = t.host.toLowerCase(), t.hash = "", t.pathname !== "/" && t.pathname.endsWith("/") && (t.pathname = t.pathname.slice(0, -1));
    for (const r of Array.from(t.searchParams.keys())) Da.has(r) && t.searchParams.delete(r);
    return t.toString();
  } catch {
    return e;
  }
}
var Ae = (e, t) => t.some((r) => e instanceof r), St, kt;
function Ua() {
  return St || (St = [
    IDBDatabase,
    IDBObjectStore,
    IDBIndex,
    IDBCursor,
    IDBTransaction
  ]);
}
function Ma() {
  return kt || (kt = [
    IDBCursor.prototype.advance,
    IDBCursor.prototype.continue,
    IDBCursor.prototype.continuePrimaryKey
  ]);
}
var Re = /* @__PURE__ */ new WeakMap(), Pe = /* @__PURE__ */ new WeakMap(), _e = /* @__PURE__ */ new WeakMap();
function La(e) {
  const t = new Promise((r, n) => {
    const i = () => {
      e.removeEventListener("success", o), e.removeEventListener("error", s);
    }, o = () => {
      r(J(e.result)), i();
    }, s = () => {
      n(e.error), i();
    };
    e.addEventListener("success", o), e.addEventListener("error", s);
  });
  return _e.set(t, e), t;
}
function Ba(e) {
  if (Re.has(e)) return;
  const t = new Promise((r, n) => {
    const i = () => {
      e.removeEventListener("complete", o), e.removeEventListener("error", s), e.removeEventListener("abort", s);
    }, o = () => {
      r(), i();
    }, s = () => {
      n(e.error || new DOMException("AbortError", "AbortError")), i();
    };
    e.addEventListener("complete", o), e.addEventListener("error", s), e.addEventListener("abort", s);
  });
  Re.set(e, t);
}
var De = {
  get(e, t, r) {
    if (e instanceof IDBTransaction) {
      if (t === "done") return Re.get(e);
      if (t === "store") return r.objectStoreNames[1] ? void 0 : r.objectStore(r.objectStoreNames[0]);
    }
    return J(e[t]);
  },
  set(e, t, r) {
    return e[t] = r, !0;
  },
  has(e, t) {
    return e instanceof IDBTransaction && (t === "done" || t === "store") ? !0 : t in e;
  }
};
function br(e) {
  De = e(De);
}
function Fa(e) {
  return Ma().includes(e) ? function(...t) {
    return e.apply(xe(this), t), J(this.request);
  } : function(...t) {
    return J(e.apply(xe(this), t));
  };
}
function Ja(e) {
  return typeof e == "function" ? Fa(e) : (e instanceof IDBTransaction && Ba(e), Ae(e, Ua()) ? new Proxy(e, De) : e);
}
function J(e) {
  if (e instanceof IDBRequest) return La(e);
  if (Pe.has(e)) return Pe.get(e);
  const t = Ja(e);
  return t !== e && (Pe.set(e, t), _e.set(t, e)), t;
}
var xe = (e) => _e.get(e);
function Va(e, t, { blocked: r, upgrade: n, blocking: i, terminated: o } = {}) {
  const s = indexedDB.open(e, t), c = J(s);
  return n && s.addEventListener("upgradeneeded", (u) => {
    n(J(s.result), u.oldVersion, u.newVersion, J(s.transaction), u);
  }), r && s.addEventListener("blocked", (u) => r(u.oldVersion, u.newVersion, u)), c.then((u) => {
    o && u.addEventListener("close", () => o()), i && u.addEventListener("versionchange", (d) => i(d.oldVersion, d.newVersion, d));
  }).catch(() => {
  }), c;
}
var Wa = [
  "get",
  "getKey",
  "getAll",
  "getAllKeys",
  "count"
], Ka = [
  "put",
  "add",
  "delete",
  "clear"
], $e = /* @__PURE__ */ new Map();
function zt(e, t) {
  if (!(e instanceof IDBDatabase && !(t in e) && typeof t == "string")) return;
  if ($e.get(t)) return $e.get(t);
  const r = t.replace(/FromIndex$/, ""), n = t !== r, i = Ka.includes(r);
  if (!(r in (n ? IDBIndex : IDBObjectStore).prototype) || !(i || Wa.includes(r))) return;
  const o = async function(s, ...c) {
    const u = this.transaction(s, i ? "readwrite" : "readonly");
    let d = u.store;
    return n && (d = d.index(c.shift())), (await Promise.all([d[r](...c), i && u.done]))[0];
  };
  return $e.set(t, o), o;
}
br((e) => ({
  ...e,
  get: (t, r, n) => zt(t, r) || e.get(t, r, n),
  has: (t, r) => !!zt(t, r) || e.has(t, r)
}));
var Ha = [
  "continue",
  "continuePrimaryKey",
  "advance"
], Pt = {}, Ue = /* @__PURE__ */ new WeakMap(), yr = /* @__PURE__ */ new WeakMap(), Ga = { get(e, t) {
  if (!Ha.includes(t)) return e[t];
  let r = Pt[t];
  return r || (r = Pt[t] = function(...n) {
    Ue.set(this, yr.get(this)[t](...n));
  }), r;
} };
async function* qa(...e) {
  let t = this;
  if (t instanceof IDBCursor || (t = await t.openCursor(...e)), !t) return;
  t = t;
  const r = new Proxy(t, Ga);
  for (yr.set(r, t), _e.set(r, xe(t)); t; )
    yield r, t = await (Ue.get(r) || t.continue()), Ue.delete(r);
}
function $t(e, t) {
  return t === Symbol.asyncIterator && Ae(e, [
    IDBIndex,
    IDBObjectStore,
    IDBCursor
  ]) || t === "iterate" && Ae(e, [IDBIndex, IDBObjectStore]);
}
br((e) => ({
  ...e,
  get(t, r, n) {
    return $t(t, r) ? qa : e.get(t, r, n);
  },
  has(t, r) {
    return $t(t, r) || e.has(t, r);
  }
}));
var Ya = class {
  constructor(e) {
    m(this, "dbPromise", null), m(this, "dbName", void 0), this.dbName = `pageloop:${e}`;
  }
  db() {
    return this.dbPromise || (this.dbPromise = Va(this.dbName, 1, { upgrade(e) {
      e.objectStoreNames.contains("pages") || e.createObjectStore("pages", { keyPath: "key" }), e.objectStoreNames.contains("comments") || e.createObjectStore("comments", { keyPath: "pageId" });
    } })), this.dbPromise;
  }
  async getPage(e) {
    try {
      return (await (await this.db()).get("pages", e))?.page ?? null;
    } catch {
      return null;
    }
  }
  async putPage(e) {
    try {
      await (await this.db()).put("pages", {
        key: e.key,
        page: e,
        cachedAt: Date.now()
      });
    } catch {
    }
  }
  async getComments(e) {
    try {
      return (await (await this.db()).get("comments", e))?.comments ?? null;
    } catch {
      return null;
    }
  }
  async putComments(e, t) {
    try {
      await (await this.db()).put("comments", {
        pageId: e,
        comments: t,
        cachedAt: Date.now()
      });
    } catch {
    }
  }
  async clear() {
    try {
      const e = await this.db();
      await e.clear("pages"), await e.clear("comments");
    } catch {
    }
  }
}, me = "pl_widget_session";
function Xa(e) {
  if (typeof window > "u") return e ?? null;
  try {
    const t = window.location.hash || "", r = new URLSearchParams(t.startsWith("#") ? t.slice(1) : t), n = r.get("pl_token");
    if (n) {
      try {
        localStorage.setItem(me, n);
      } catch {
      }
      r.delete("pl_token"), r.delete("pl_project");
      const i = r.toString(), o = i ? `#${i}` : "", s = window.location.pathname + window.location.search + o;
      try {
        window.history.replaceState(null, "", s);
      } catch {
      }
      return n;
    }
  } catch {
  }
  try {
    const t = localStorage.getItem(me);
    if (t) return t;
  } catch {
  }
  return e ?? null;
}
var Qa = class {
  constructor(e) {
    m(this, "bus", void 0), m(this, "debug", void 0), m(this, "off", null), this.bus = e.bus, this.debug = e.debug ?? (() => {
    });
  }
  start(e = {}) {
    if (!this.off) {
      if (typeof window > "u" || typeof Notification > "u") {
        this.debug("[notifications] window or Notification API unavailable");
        return;
      }
      if (!e.force && Notification.permission !== "granted") {
        this.debug("[notifications] permission not granted — deferring subscription until grant");
        return;
      }
      this.off = this.bus.on("notification.show", (t) => {
        this.handleEvent(t).catch((r) => this.debug("[notifications] handleEvent failed", r));
      });
    }
  }
  stop() {
    this.off?.(), this.off = null;
  }
  permission() {
    return typeof Notification > "u" ? "denied" : Notification.permission;
  }
  async requestPermission() {
    if (typeof Notification > "u") return "denied";
    if (Notification.permission === "granted")
      return this.start({ force: !0 }), "granted";
    if (Notification.permission === "denied") return "denied";
    try {
      const e = await Notification.requestPermission();
      return e === "granted" && this.start({ force: !0 }), e;
    } catch {
      return "denied";
    }
  }
  async handleEvent(e) {
    if (Notification.permission !== "granted") {
      this.debug("[notifications] received but permission not granted", e);
      return;
    }
    const t = e.envelope;
    if (!t) return;
    const { title: r, body: n, url: i } = this.renderTitle(t), o = t.commentId ?? t.replyId ?? t.messageId ?? t.sourceId ?? t.kind, s = new Notification(r, {
      body: n,
      tag: o
    });
    s.onclick = (c) => {
      c.preventDefault(), s.close();
      try {
        window.focus();
      } catch {
      }
      if (i) try {
        window.location.assign(i);
      } catch {
      }
    };
  }
  renderTitle(e) {
    const t = e.pageTitle ?? "a page";
    switch (e.kind) {
      case "comment.created":
        return {
          title: `${e.authorName} commented on ${t}`,
          body: e.excerpt,
          url: e.pageUrl && e.commentId ? `${e.pageUrl}#pl-comment=${e.commentId}` : null
        };
      case "reply.created":
        return {
          title: `${e.authorName} replied on ${t}`,
          body: e.excerpt,
          url: e.pageUrl && e.parentCommentId ? `${e.pageUrl}#pl-comment=${e.parentCommentId}` : null
        };
      case "chat.message":
        return {
          title: `${e.authorName} sent a message`,
          body: e.excerpt,
          url: e.pageUrl ?? null
        };
      case "mention":
        return {
          title: `${e.authorName} mentioned you on ${t}`,
          body: e.excerpt,
          url: e.pageUrl ?? null
        };
    }
  }
}, Te = /* @__PURE__ */ new Map(), F = !0;
function ec() {
  if (typeof window > "u" || typeof localStorage > "u") {
    F = !1;
    return;
  }
  try {
    const e = "__ld_probe__";
    localStorage.setItem(e, "1"), localStorage.removeItem(e), F = !0;
  } catch {
    F = !1;
  }
}
ec();
var U = {
  getItem(e) {
    if (F) try {
      return localStorage.getItem(e);
    } catch {
    }
    return Te.get(e) ?? null;
  },
  setItem(e, t) {
    if (F) try {
      localStorage.setItem(e, t);
      return;
    } catch {
    }
    Te.set(e, t);
  },
  removeItem(e) {
    if (F) try {
      localStorage.removeItem(e);
      return;
    } catch {
    }
    Te.delete(e);
  },
  isPersistent() {
    return F;
  }
}, _r = "pl_config:", wr = "pl_project:", Ge = "pl_widget_user:", vl = "pl_draft:", Tt = "pl_org_name";
function tc(e) {
  const t = U.getItem(_r + e);
  if (!t) return null;
  try {
    return JSON.parse(t);
  } catch {
    return null;
  }
}
function rc(e, t) {
  U.setItem(_r + e, JSON.stringify(t));
}
function nc(e) {
  const t = U.getItem(wr + e);
  if (!t) return null;
  try {
    const r = JSON.parse(t);
    return !r.id || !r.slug ? null : r;
  } catch {
    return null;
  }
}
function Et(e, t) {
  U.setItem(wr + e, JSON.stringify(t));
}
function Ot(e) {
  e ? U.setItem(Tt, e) : U.removeItem(Tt);
}
function ic(e) {
  const t = U.getItem(Ge + e);
  if (!t) return null;
  try {
    const r = JSON.parse(t);
    return !r || typeof r.role != "string" ? null : r;
  } catch {
    return null;
  }
}
function jt(e, t) {
  U.setItem(Ge + e, JSON.stringify(t));
}
function Ee(e) {
  U.removeItem(Ge + e);
}
var oc = 6e4, bl = class {
  constructor(e, t) {
    m(this, "config", void 0), m(this, "bus", void 0), m(this, "api", void 0), m(this, "tracker", void 0), m(this, "comments", void 0), m(this, "cache", void 0), m(this, "notifications", void 0), m(this, "renderer", void 0), m(this, "project", null), m(this, "currentPage", null), m(this, "pageLookupInFlight", !0), m(this, "currentUser", null), m(this, "currentRole", "anonymous"), m(this, "currentBubbleColor", null), m(this, "lastBootstrapAt", 0), m(this, "visibilityWired", !1), m(this, "offHandlers", []), m(this, "offProjectUpdated", null), m(this, "offBubbleRecolor", null), m(this, "phase2Active", !1), m(this, "dismissed", !1), m(this, "sidebarHandle", null), m(this, "toolbarHandle", null), m(this, "danglingCommentIds", /* @__PURE__ */ new Set()), m(this, "serverSettings", void 0), m(this, "titleSyncTimer", null), m(this, "onVisible", () => {
      typeof document > "u" || document.visibilityState !== "visible" || this.currentUser && (Date.now() - this.lastBootstrapAt < oc || this.reBootstrap());
    }), this.config = e, this.bus = new Na(), this.notifications = new Qa({
      bus: this.bus,
      debug: (...i) => this.debug(...i)
    }), this.notifications.start(), this.serverSettings = tc(e.projectId) ?? {}, this.project = nc(e.projectId);
    const r = this.serverSettings.behavior ?? {}, n = Xa(e.token);
    if (n) {
      const i = ic(e.projectId);
      i && (this.currentUser = i.user, this.currentRole = i.role);
    }
    this.api = new He({
      endpoint: e.endpoint,
      projectId: e.projectId,
      token: n,
      transport: e.transport ?? r.transport
    }, this.bus), this.tracker = new Ra(this.bus), this.comments = new Aa(this.api, this.bus), this.cache = new Ya(e.projectId), this.renderer = t.renderer;
  }
  effectiveUi() {
    const e = this.config.ui ?? {}, t = this.serverSettings.ui ?? {}, r = t.sidebarPosition ?? e.sidebarPosition ?? t.sidebarSide ?? e.sidebarSide;
    return {
      toolbarPosition: t.toolbarPosition ?? e.toolbarPosition,
      widgetMode: t.widgetMode ?? e.widgetMode,
      widgetCorner: t.widgetCorner ?? e.widgetCorner,
      sidebarPosition: r,
      sidebarSide: t.sidebarSide ?? e.sidebarSide,
      sidebarDisplayMode: t.sidebarDisplayMode ?? e.sidebarDisplayMode,
      theme: t.theme ?? e.theme,
      allowInlineCommenting: t.allowInlineCommenting ?? e.allowInlineCommenting,
      tooltipDelayMs: t.tooltipDelayMs ?? e.tooltipDelayMs,
      bubbleFollowAnimations: t.bubbleFollowAnimations ?? e.bubbleFollowAnimations,
      bubbleZIndex: t.bubbleZIndex ?? e.bubbleZIndex,
      signInMode: t.signInMode ?? e.signInMode
    };
  }
  effectiveBehavior() {
    const e = this.serverSettings.behavior ?? {};
    return {
      enabled: e.enabled,
      autoDiscover: e.autoDiscover ?? this.config.autoDiscover,
      transport: e.transport ?? this.config.transport
    };
  }
  isWidgetEnabled() {
    return this.effectiveBehavior().enabled !== !1;
  }
  reconcileSettings(e) {
    const t = e ?? {};
    JSON.stringify(this.serverSettings) !== JSON.stringify(t) && (this.serverSettings = t, rc(this.config.projectId, t), this.bus.emit("config:changed", {
      settings: t,
      ui: this.effectiveUi()
    }));
  }
  async mountRenderer() {
    const e = await this.renderer.mount({
      bus: this.bus,
      api: this.api,
      comments: this.comments,
      notifications: this.notifications,
      page: () => this.currentPage,
      project: () => this.project,
      user: () => this.currentUser,
      role: () => this.currentRole,
      bubbleColor: () => this.currentBubbleColor,
      applyToken: (t) => this.applyToken(t),
      dismiss: () => {
        this.dismiss();
      },
      ui: () => this.effectiveUi(),
      registerCurrentPage: () => this.registerCurrentPage().catch((t) => (console.warn("[PageLoop] registerCurrentPage failed:", t), null)),
      pageKey: () => this.tracker.pageKey(),
      debug: (...t) => this.debug(...t),
      release: () => ({
        version: this.config.version,
        notesUrl: this.config.releaseNotesUrl
      })
    });
    this.sidebarHandle = e.sidebar, this.toolbarHandle = e.toolbar, this.api.replayConnectionState();
  }
  async start() {
    this.debug("start: config", {
      endpoint: this.config.endpoint,
      projectId: this.config.projectId,
      hasToken: !!this.config.token
    });
    const e = this.tracker.pageKey();
    this.debug("start: pageKey", e);
    const t = await this.cache.getPage(e);
    if (t) {
      this.debug("start: idb cache hit, optimistic paint", { pageId: t.id }), this.currentPage = t, this.pageLookupInFlight = !1;
      const o = await this.cache.getComments(t.id);
      o && this.comments.prime(t.id, o);
    }
    const r = this.isWidgetEnabled();
    if (r && this.project) {
      this.debug("start: optimistic Phase 2 from cached project + enabled", { slug: this.project.slug });
      try {
        await this.runPhase2();
      } catch (o) {
        this.debug("start: optimistic Phase 2 failed, will retry post-bootstrap", o);
      }
    } else r || this.debug("start: widget disabled in cache, deferring Phase 2");
    let n = null, i = null;
    try {
      n = await this.api.call("bootstrap", {
        projectId: this.config.projectId,
        pageKey: e
      });
    } catch (o) {
      if (i = o, It(o) === Se.UNAUTHORIZED && this.api.getToken()) {
        this.debug("start: bootstrap UNAUTHORIZED — dropping in-memory token, retrying anon"), this.api.setToken(null), Ee(this.config.projectId), this.currentUser = null, this.currentRole = "anonymous";
        try {
          n = await this.api.call("bootstrap", {
            projectId: this.config.projectId,
            pageKey: e
          }), i = null;
        } catch (s) {
          i = s, this.debug("start: anonymous bootstrap also failed", s);
        }
      } else this.debug("start: bootstrap failed", o);
    }
    if (!n) {
      const o = i instanceof Error ? i.message : String(i), s = It(i), c = o.includes("requires a project scope") ? `Project "${this.config.projectId}" not found at ${this.config.endpoint}. Check projectId or confirm the server hosting this project is the one running on that endpoint.` : s === Se.UNAUTHORIZED ? "Server rejected the request (UNAUTHORIZED) and anonymous fallback also failed. The project likely requires sign-in (publicRead is off)." : s === Se.FORBIDDEN ? "Anonymous access denied. Either sign in, or enable publicRead in the project settings." : `Could not reach ${this.config.endpoint}: ${o}`;
      console.warn(`[PageLoop] widget will not mount — ${c}`), this.pageLookupInFlight = !1;
      return;
    }
    this.project = n.project, this.currentPage = n.page, this.pageLookupInFlight = !1, this.currentUser = n.user, this.currentRole = n.role, this.currentBubbleColor = n.bubbleColor ?? null, Et(this.config.projectId, n.project), Ot(n.organizationName ?? null), n.user ? jt(this.config.projectId, {
      user: n.user,
      role: n.role
    }) : Ee(this.config.projectId), this.reconcileSettings(n.project.settings), this.bus.emit("auth:changed", {
      user: this.currentUser,
      role: this.currentRole
    }), this.lastBootstrapAt = Date.now(), !this.visibilityWired && typeof document < "u" && (this.visibilityWired = !0, document.addEventListener("visibilitychange", this.onVisible)), this.debug("start: bootstrap", {
      project: n.project.slug,
      page: n.page?.id ?? null,
      comments: n.comments.length,
      user: n.user?.email ?? null,
      role: n.role
    }), n.page && (this.comments.prime(n.page.id, n.comments), await this.cache.putPage(n.page), await this.cache.putComments(n.page.id, n.comments)), this.offProjectUpdated || (this.offProjectUpdated = this.bus.on("projects.updated", (o) => {
      !this.project || o?.project?.id !== this.project.id || (this.project = o.project, this.reconcileSettings(o.project.settings), this.bus.emit("project:updated", o.project), this.reEvaluatePhase2(), this.phase2Active && this.refreshSidebar());
    })), this.offBubbleRecolor || (this.offBubbleRecolor = this.bus.on("bubbles:recolor", (o) => {
      this.currentBubbleColor = o?.color ?? null;
    })), await this.reEvaluatePhase2(), this.phase2Active && (this.refreshSidebar(), this.refreshBubbles());
  }
  async runPhase2() {
    if (this.phase2Active) return;
    if (this.phase2Active = !0, this.debug("phase2: starting"), this.scheduleIdle(() => {
      this.api.connect().catch((s) => {
        this.debug("phase2: connect failed", s);
      });
    }), await this.mountRenderer(), !this.currentPage && (this.effectiveBehavior().autoDiscover ?? !0)) {
      this.debug("phase2: auto-discovering current page");
      try {
        await this.registerCurrentPage();
      } catch (s) {
        this.debug("phase2: auto-discover failed", s);
        const c = s instanceof Error ? s.message : String(s);
        /^(FORBIDDEN|UNAUTHORIZED)\b/.test(c) || this.notify("Couldn't set up PageLoop on this page — comments may be unavailable. Try reloading.", {
          kind: "error",
          durationMs: 6e3
        });
      }
    }
    this.refreshSidebar(), this.refreshBubbles(), this.maybeFocusFromUrl(), this.tracker.start();
    const e = this.bus.on("page:change", async ({ key: s }) => {
      await this.resolvePage(s), this.scheduleTitleSync();
    }), t = this.bus.on("comment:created", () => this.refreshAfterChange()), r = this.bus.on("comment:updated", () => this.refreshAfterChange()), n = this.bus.on("comment:deleted", () => this.refreshAfterChange()), i = this.bus.on("comment:bulkDeleted", () => this.refreshAfterChange()), o = this.bus.on("bubbles:dangling", (s) => {
      const c = s?.ids instanceof Set ? s.ids : /* @__PURE__ */ new Set(), u = c.size !== this.danglingCommentIds.size || [...c].some((d) => !this.danglingCommentIds.has(d));
      this.danglingCommentIds = c, u && this.refreshSidebar();
    });
    this.offHandlers.push(e, t, r, n, i, o, () => {
      this.titleSyncTimer && clearTimeout(this.titleSyncTimer), this.titleSyncTimer = null;
    }), this.scheduleTitleSync();
  }
  scheduleTitleSync() {
    this.titleSyncTimer && clearTimeout(this.titleSyncTimer), this.titleSyncTimer = setTimeout(() => {
      this.titleSyncTimer = null, this.syncCurrentPageTitle();
    }, 600);
  }
  async syncCurrentPageTitle() {
    if (!this.project || !(this.effectiveBehavior().autoDiscover ?? !0)) return;
    const e = (typeof document < "u" ? document.title : "").trim();
    if (e && !(this.currentPage && this.currentPage.title === e))
      try {
        await this.registerCurrentPage(e);
      } catch (t) {
        this.debug("title sync skipped", t);
      }
  }
  async tearDownPhase2() {
    if (this.phase2Active) {
      this.debug("phase2: tearing down"), this.phase2Active = !1, this.tracker.stop();
      for (const e of this.offHandlers) e();
      this.offHandlers = [], await this.renderer.unmount(), this.sidebarHandle = null, this.toolbarHandle = null, this.api.disconnect();
    }
  }
  async dismiss() {
    this.dismissed = !0, await this.tearDownPhase2();
  }
  async reEvaluatePhase2() {
    const e = this.isWidgetEnabled() && !this.dismissed;
    e && !this.phase2Active ? await this.runPhase2() : !e && this.phase2Active && await this.tearDownPhase2();
  }
  async stop() {
    this.notifications.stop(), this.offProjectUpdated && (this.offProjectUpdated(), this.offProjectUpdated = null), this.offBubbleRecolor && (this.offBubbleRecolor(), this.offBubbleRecolor = null), this.visibilityWired && typeof document < "u" && (document.removeEventListener("visibilitychange", this.onVisible), this.visibilityWired = !1), this.phase2Active && await this.tearDownPhase2();
  }
  getCurrentPage() {
    return this.currentPage;
  }
  getProject() {
    return this.project;
  }
  getCurrentUser() {
    return this.currentUser;
  }
  getCurrentRole() {
    return this.currentRole;
  }
  async applyToken(e) {
    this.api.setToken(e);
    try {
      e ? localStorage.setItem(me, e) : localStorage.removeItem(me);
    } catch {
    }
    await this.reBootstrap();
  }
  async reBootstrap() {
    try {
      const e = await this.api.call("bootstrap", {
        projectId: this.config.projectId,
        pageKey: this.tracker.pageKey()
      });
      this.lastBootstrapAt = Date.now(), this.project = e.project, this.currentPage = e.page, this.currentUser = e.user, this.currentRole = e.role, this.currentBubbleColor = e.bubbleColor ?? null, Et(this.config.projectId, e.project), Ot(e.organizationName ?? null), e.user ? jt(this.config.projectId, {
        user: e.user,
        role: e.role
      }) : Ee(this.config.projectId), this.reconcileSettings(e.project.settings), e.page && (this.comments.prime(e.page.id, e.comments), await this.cache.putPage(e.page), await this.cache.putComments(e.page.id, e.comments)), this.bus.emit("auth:changed", {
        user: this.currentUser,
        role: this.currentRole
      }), await this.reEvaluatePhase2(), this.phase2Active && (this.refreshSidebar(), this.refreshBubbles());
    } catch (e) {
      this.debug("reBootstrap failed", e), this.bus.emit("auth:changed", {
        user: this.currentUser,
        role: this.currentRole
      });
    }
  }
  async registerCurrentPage(e) {
    if (!this.project) throw new Error("PageLoop not started");
    const t = this.tracker.pageKey(), r = await this.api.call("pages.register", {
      projectId: this.project.id,
      sourceKind: "live",
      sourceId: this.project.id,
      key: t,
      title: e ?? document.title
    });
    return this.currentPage = r, await this.comments.loadFromServer(r.id), this.refreshSidebar(), this.refreshBubbles(), r;
  }
  async resolvePage(e) {
    if (!this.project) return;
    const t = await this.cache.getPage(e);
    if (t) {
      this.currentPage = t, this.pageLookupInFlight = !1;
      const n = await this.cache.getComments(t.id);
      n && this.comments.prime(t.id, n), this.refreshSidebar(), this.refreshBubbles();
    } else
      this.currentPage = null, this.pageLookupInFlight = !0, this.refreshSidebar(), this.refreshBubbles();
    const r = await this.api.call("pages.byKey", {
      projectId: this.project.id,
      key: e
    });
    if (this.pageLookupInFlight = !1, r && r.settings.displayVisibility === "disabled") {
      this.currentPage = null, this.refreshSidebar(), this.refreshBubbles();
      return;
    }
    if (this.currentPage = r, r) {
      const n = await this.comments.loadFromServer(r.id);
      await this.cache.putPage(r), await this.cache.putComments(r.id, n);
    }
    this.refreshSidebar(), this.refreshBubbles();
  }
  debug(...e) {
    this.config.debug && console.debug("[PageLoop]", ...e);
  }
  scheduleIdle(e) {
    if (typeof window > "u") return;
    const t = window.requestIdleCallback;
    if (typeof t == "function") {
      t(e, { timeout: 3e3 });
      return;
    }
    setTimeout(e, 50);
  }
  maybeFocusFromUrl() {
    if (typeof window > "u") return;
    const e = new URLSearchParams(window.location.search), t = e.get("pl-comment"), r = e.get("pl-reply");
    if (t && this.sidebarHandle) {
      try {
        r ? this.sidebarHandle.focusReply(t, r) : this.sidebarHandle.focusComment(t);
      } catch (n) {
        this.debug("maybeFocusFromUrl: focus failed", n);
      }
      try {
        e.delete("pl-comment"), e.delete("pl-reply");
        const n = `${window.location.pathname}${e.toString() ? `?${e.toString()}` : ""}${window.location.hash}`;
        window.history.replaceState({}, "", n);
      } catch {
      }
    }
  }
  focusComment(e, t) {
    if (this.sidebarHandle)
      try {
        t ? this.sidebarHandle.focusReply(e, t) : this.sidebarHandle.focusComment(e);
      } catch (r) {
        this.debug("focusComment: failed", r);
      }
  }
  static buildDeepLink(e) {
    const t = e.url ?? (typeof window > "u" ? (() => {
      throw new Error("PageLoop.buildDeepLink: no `url` in non-browser context");
    })() : window.location.href), r = typeof window > "u" ? new URL(t) : new URL(t, window.location.href);
    return r.searchParams.set("pl-comment", e.commentId), e.replyId ? r.searchParams.set("pl-reply", e.replyId) : r.searchParams.delete("pl-reply"), r.toString();
  }
  refreshAfterChange() {
    this.refreshSidebar(), this.refreshBubbles(), this.currentPage && this.cache.putComments(this.currentPage.id, this.comments.load(this.currentPage.id));
  }
  refreshSidebar() {
    const e = this.currentPage ? this.comments.load(this.currentPage.id) : [];
    this.renderer.renderSidebar({
      page: this.currentPage,
      comments: e,
      danglingCommentIds: this.danglingCommentIds,
      loading: this.pageLookupInFlight && !this.currentPage
    });
  }
  refreshBubbles() {
    const e = this.currentPage ? this.comments.load(this.currentPage.id) : [];
    this.renderer.renderBubbles(e);
    const t = e.length;
    this.toolbarHandle?.setUnreadCount(t);
  }
  reflowBubbles() {
    this.renderer.reflowBubbles?.();
  }
  repositionBubbles() {
    this.refreshBubbles(), this.refreshSidebar();
  }
  setBubblesHidden(e, t) {
    this.renderer.setBubblesHidden?.(e, t);
  }
  notify(e, t) {
    this.bus.emit("toast:show", {
      kind: t?.kind ?? "info",
      message: e,
      duration: t?.durationMs
    });
  }
};
export {
  U as a,
  sc as c,
  Ge as i,
  vl as n,
  me as o,
  Tt as r,
  m as s,
  bl as t
};
